export default {
  abi: [
    {
      inputs: [
        {
          internalType: "address",
          name: "uniswapV3Factory_",
          type: "address"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [],
      name: "T",
      type: "error"
    },
    {
      anonymous: false,
      inputs: [
        {
          components: [
            {
              internalType: "address",
              name: "poolAddress",
              type: "address"
            },
            {
              internalType: "uint24",
              name: "fee",
              type: "uint24"
            },
            {
              internalType: "uint48",
              name: "lastUpdatedTimestamp",
              type: "uint48"
            }
          ],
          indexed: false,
          internalType: "struct PoolData",
          name: "pool",
          type: "tuple"
        }
      ],
      name: "PoolUpdated",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenA",
          type: "address"
        },
        {
          internalType: "address",
          name: "tokenB",
          type: "address"
        }
      ],
      name: "getPool",
      outputs: [
        {
          components: [
            {
              internalType: "address",
              name: "poolAddress",
              type: "address"
            },
            {
              internalType: "uint24",
              name: "fee",
              type: "uint24"
            },
            {
              internalType: "uint48",
              name: "lastUpdatedTimestamp",
              type: "uint48"
            }
          ],
          internalType: "struct PoolData",
          name: "pool",
          type: "tuple"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint128",
          name: "baseAmount",
          type: "uint128"
        },
        {
          internalType: "address",
          name: "baseToken",
          type: "address"
        },
        {
          internalType: "address",
          name: "quoteToken",
          type: "address"
        },
        {
          internalType: "uint32",
          name: "secondsAgo",
          type: "uint32"
        }
      ],
      name: "getQuote",
      outputs: [
        {
          internalType: "uint256",
          name: "quoteAmount",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint128",
          name: "baseAmount",
          type: "uint128"
        },
        {
          internalType: "address",
          name: "baseToken",
          type: "address"
        },
        {
          internalType: "address",
          name: "quoteToken",
          type: "address"
        },
        {
          internalType: "uint32",
          name: "secondsAgo",
          type: "uint32"
        },
        {
          internalType: "uint256",
          name: "updateInterval",
          type: "uint256"
        }
      ],
      name: "getQuoteAndUpdatePool",
      outputs: [
        {
          internalType: "uint256",
          name: "quoteAmount",
          type: "uint256"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenA",
          type: "address"
        },
        {
          internalType: "address",
          name: "tokenB",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "updateInterval",
          type: "uint256"
        }
      ],
      name: "getUpdatedPool",
      outputs: [
        {
          components: [
            {
              internalType: "address",
              name: "poolAddress",
              type: "address"
            },
            {
              internalType: "uint24",
              name: "fee",
              type: "uint24"
            },
            {
              internalType: "uint48",
              name: "lastUpdatedTimestamp",
              type: "uint48"
            }
          ],
          internalType: "struct PoolData",
          name: "pool",
          type: "tuple"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        },
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "pools",
      outputs: [
        {
          internalType: "address",
          name: "poolAddress",
          type: "address"
        },
        {
          internalType: "uint24",
          name: "fee",
          type: "uint24"
        },
        {
          internalType: "uint48",
          name: "lastUpdatedTimestamp",
          type: "uint48"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "uniswapV3Factory",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "tokenA",
          type: "address"
        },
        {
          internalType: "address",
          name: "tokenB",
          type: "address"
        }
      ],
      name: "updatePool",
      outputs: [
        {
          components: [
            {
              internalType: "address",
              name: "poolAddress",
              type: "address"
            },
            {
              internalType: "uint24",
              name: "fee",
              type: "uint24"
            },
            {
              internalType: "uint48",
              name: "lastUpdatedTimestamp",
              type: "uint48"
            }
          ],
          internalType: "struct PoolData",
          name: "highestLiquidityPool",
          type: "tuple"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    }
  ],
  bytecode: {
    object:
      "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",
    sourceMap:
      "859:47:0:-:0;466:9834;859:47;884:5;466:9834;859:47;;;891:4;859:47;;897:3;859:47;;902:3;859:47;;;;-1:-1:-1;;859:47:0;;:::i;:::-;;1343:86;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;;;;;1388:36:0;;;466:9834;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;466:9834:0;;;-1:-1:-1;466:9834:0;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;14:290:25;84:6;137:2;125:9;116:7;112:23;108:32;105:52;;;153:1;150;143:12;105:52;179:16;;-1:-1:-1;;;;;224:31:25;;214:42;;204:70;;270:1;267;260:12;204:70;293:5;14:290;-1:-1:-1;;;14:290:25:o;:::-;466:9834:0;;;;;;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object:
      "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",
    sourceMap:
      "466:9834:0:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1838:252;;;;;;:::i;:::-;;:::i;:::-;;;;784:13:25;;799:42;780:62;762:81;;903:4;891:17;;;885:24;911:8;881:39;859:20;;;852:69;969:17;;;963:24;989:14;959:45;937:20;;;930:75;750:2;735:18;1838:252:0;;;;;;;;949:41;;;;;;;;1192:42:25;1180:55;;;1162:74;;1150:2;1135:18;949:41:0;1016:226:25;2766:484:0;;;;;;:::i;:::-;;:::i;:::-;;;2294:25:25;;;2282:2;2267:18;2766:484:0;2148:177:25;3816:550:0;;;;;;:::i;:::-;;:::i;6015:1556::-;;;;;;:::i;:::-;;:::i;1156:61::-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3019:42:25;3007:55;;;2989:74;;3111:8;3099:21;;;3094:2;3079:18;;3072:49;3169:14;3157:27;3137:18;;;3130:55;2977:2;2962:18;1156:61:0;2791:400:25;5153:550:0;;;;;;:::i;:::-;;:::i;1838:252::-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;1951:14:0;1967;1994:6;1985:15;;:6;:15;;;:65;;2035:6;2043;1985:65;;;2010:6;2018;1985:65;2064:13;;;;;;;;:5;:13;;;;;;;;:21;;;;;;;;;;;;2057:28;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;1838:252:0:o;2766:484::-;2903:19;2930:12;2945:30;2953:9;2964:10;2945:7;:30::i;:::-;:42;;-1:-1:-1;2998:18:0;;;;2994:252;;3026:24;3053:40;3076:4;3082:10;3053:22;:40::i;:::-;3026:67;;3116:123;3154:18;3182:10;3202:9;3221:10;3116:28;:123::i;:::-;3102:137;;3018:228;2994:252;2924:326;2766:484;;;;;;:::o;3816:550::-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;4013:14:0;4031:1;4013:19;4009:58;;4041:26;4052:6;4060;4041:10;:26::i;:::-;4034:33;;;;4009:58;4081:23;4089:6;4097;4081:7;:23::i;:::-;4206:16;;4074:30;;-1:-1:-1;4206:30:0;;;;:101;;;4292:15;4274:14;4246:4;:25;;;:42;;;;;;:::i;:::-;:61;;4206:101;4195:167;;;4329:26;4340:6;4348;4329:10;:26::i;:::-;4322:33;;4195:167;3816:550;;;;;:::o;6015:1556::-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;6167:14:0;6183;6210:6;6201:15;;:6;:15;;;:65;;6251:6;6259;6201:65;;;6226:6;6234;6201:65;6166:100;;;;6331:24;6407:21;6431:4;6407:28;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6441:19;6466:29;6506:9;6501:808;6521:1;6517;:5;6501:808;;;6578:115;6614:16;6640:45;;;;;;;;6660:6;6640:45;;;;;;6668:6;6640:45;;;;;;6676:5;6682:1;6676:8;;;;;;;;:::i;:::-;;;;;;;6640:45;;;;;6578:26;:115::i;:::-;6564:129;-1:-1:-1;6741:23:0;;;;:27;6737:526;;6850:44;6876:11;6889:4;6850:25;:44::i;:::-;6826:68;;;;6998:16;6974:21;:40;6970:285;;;7084:21;7065:40;;7140:104;;;;;;;;7162:11;7140:104;;;;;;7187:5;7193:1;7187:8;;;;;;;;:::i;:::-;;;;;;;7140:104;;;;;;7216:15;7140:104;;;;;7117:127;;6970:285;7291:3;;6501:808;;;-1:-1:-1;7478:13:0;;;;;;;;:5;:13;;;;;;;;:21;;;;;;;;;;;:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7533:33;;762:81:25;;;885:24;881:39;;;859:20;;;852:69;;;;963:24;;959:45;937:20;;;930:75;7533:33:0;;750:2:25;735:18;7533:33:0;;;;;;;6131:1440;;;;;;6015:1556;;;;:::o;5153:550::-;5326:19;5353:12;5368:53;5383:9;5394:10;5406:14;5368;:53::i;:::-;:72;;-1:-1:-1;5451:18:0;;;;5447:252;;5479:24;5506:40;5529:4;5535:10;5506:22;:40::i;:::-;5479:67;;5569:123;5607:18;5635:10;5655:9;5674:10;5569:28;:123::i;:::-;5555:137;;5471:228;5447:252;5347:356;5153:550;;;;;;;:::o;7961:718::-;8060:24;8102:10;:15;;8116:1;8102:15;8094:30;;;;;;;4515:2:25;8094:30:0;;;4497:21:25;4554:1;4534:18;;;4527:29;4592:4;4572:18;;;4565:32;4614:18;;8094:30:0;;;;;;;;8161:15;;;8174:1;8161:15;;;;;;;;8131:27;;8161:15;;;;;;;;;;-1:-1:-1;8161:15:0;8131:45;;8199:10;8182:11;8194:1;8182:14;;;;;;;;:::i;:::-;;;;;;:27;;;;;;;;;;;8232:1;8215:11;8227:1;8215:14;;;;;;;;:::i;:::-;:18;;;;:14;;;;;;;;;;;:18;8277:53;;;;;8241:30;;8277:28;;;;;;:53;;8313:11;;8277:53;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;8240:90;;;8337:26;8387:15;8403:1;8387:18;;;;;;;;:::i;:::-;;;;;;;8366:15;8382:1;8366:18;;;;;;;;:::i;:::-;;;;;;;:39;;;;:::i;:::-;8337:68;-1:-1:-1;8446:48:0;8475:18;;;8337:68;8446:48;:::i;:::-;8412:88;;8581:1;8558:20;:24;;;:89;;;;-1:-1:-1;8593:48:0;8622:18;;;8593:20;:48;:::i;:::-;:53;;;;8558:89;8547:127;;;8654:20;;;;:::i;:::-;;;;8547:127;8088:591;;;7961:718;;;;:::o;2647:955:23:-;2803:19;2834:20;2857:33;2885:4;2857:27;:33::i;:::-;2834:56;-1:-1:-1;3025:17:23;3009:33;;;;3005:591;;3058:17;3078:36;;;;;;:::i;:::-;3058:56;;3154:10;3142:22;;:9;:22;;;:156;;3250:48;3266:8;3276:10;3250:48;;3288:9;3250:15;:48::i;:::-;3142:156;;;3183:48;3199:9;3210:10;3183:48;;3222:8;3183:15;:48::i;:::-;3128:170;;3044:265;3005:591;;;3329:17;3349:52;;;;;3393:7;3349:15;:52::i;:::-;3329:72;;3441:10;3429:22;;:9;:22;;;:156;;3537:48;3553:8;3563:10;3537:48;;3575:9;3537:15;:48::i;:::-;3429:156;;;3470:48;3486:9;3497:10;3470:48;;3509:8;3470:15;:48::i;1214:459:3:-;1310:12;1353:3;:10;;;1340:23;;:3;:10;;;:23;;;1332:32;;;;;;1550:10;;1562;;;;;1574:7;;;;;1539:43;;9822:42:25;9891:15;;;1539:43:3;;;9873:34:25;9943:15;;;;9923:18;;;9916:43;10007:8;9995:21;;;9975:18;;;;9968:49;;;;1539:43:3;;;;;;;;;9785:18:25;;;1539:43:3;;;1529:54;;;;;;;10326:66:25;1451:181:3;;;10314:79:25;10426:15;;;;10443:66;10422:88;10409:11;;;10402:109;10527:12;;;10520:28;212:66:3;10564:12:25;;;10557:28;10601:12;;1451:181:3;;;;;;;;;;;;;1428:216;;1451:181;1428:216;;;;;1214:459;-1:-1:-1;;;1214:459:3:o;9171:1127:0:-;9342:15;;;9355:1;9342:15;;;;;;;;9273:29;;;;9342:15;9355:1;9342:15;;;;;;;;;;-1:-1:-1;9342:15:0;9312:45;;9380:10;9363:11;9375:1;9363:14;;;;;;;;:::i;:::-;;;;;;:27;;;;;;;;;;;9413:1;9396:11;9408:1;9396:14;;;;;;;;:::i;:::-;;;;;;:18;;;;;;;;;;;9456:12;9470:17;9491:4;:15;;9537:10;9549:11;9514:47;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9491:76;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9455:112;;;;9612:7;9608:686;;;9704:51;9779:4;9759:62;;;;;;;;;;;;:::i;:::-;9701:120;;;9830:43;9936:34;9971:1;9936:37;;;;;;;;:::i;:::-;;;;;;;9876:34;9922:1;9876:57;;;;;;;;:::i;:::-;;;;;;;:97;;;;:::i;:::-;9830:143;-1:-1:-1;10097:22:0;10122:39;10144:17;10122:19;;;:39;:::i;:::-;10097:64;-1:-1:-1;10210:69:0;10228:50;10276:2;10228:50;;;;10097:64;10210:69;:::i;:::-;10169:118;9171:1127;-1:-1:-1;;;;;;;;;9171:1127:0:o;1385:2759:22:-;1448:20;1504:15;1529:1;1522:4;:8;;;:57;;1573:4;1566:12;;1522:57;;;1549:4;1542:12;;1541:13;;1522:57;1504:75;-1:-1:-1;667:9:22;1597:35;;1593:51;;;1641:3;;;;;;;;;;;;;;1593:51;1659:13;1675:7;1685:3;1675:13;1692:1;1675:18;:125;;1765:35;1675:125;;;1712:34;1675:125;1659:141;;;-1:-1:-1;1828:3:22;1818:13;;:18;1814:83;;1855:34;1847:42;1894:3;1846:51;1814:83;1925:3;1915:13;;:18;1911:83;;1952:34;1944:42;1991:3;1943:51;1911:83;2022:3;2012:13;;:18;2008:83;;2049:34;2041:42;2088:3;2040:51;2008:83;2119:4;2109:14;;:19;2105:84;;2147:34;2139:42;2186:3;2138:51;2105:84;2217:4;2207:14;;:19;2203:84;;2245:34;2237:42;2284:3;2236:51;2203:84;2315:4;2305:14;;:19;2301:84;;2343:34;2335:42;2382:3;2334:51;2301:84;2413:4;2403:14;;:19;2399:84;;2441:34;2433:42;2480:3;2432:51;2399:84;2511:5;2501:15;;:20;2497:85;;2540:34;2532:42;2579:3;2531:51;2497:85;2610:5;2600:15;;:20;2596:85;;2639:34;2631:42;2678:3;2630:51;2596:85;2709:5;2699:15;;:20;2695:85;;2738:34;2730:42;2777:3;2729:51;2695:85;2808:5;2798:15;;:20;2794:85;;2837:34;2829:42;2876:3;2828:51;2794:85;2907:6;2897:16;;:21;2893:86;;2937:34;2929:42;2976:3;2928:51;2893:86;3007:6;2997:16;;:21;2993:86;;3037:34;3029:42;3076:3;3028:51;2993:86;3107:6;3097:16;;:21;3093:86;;3137:34;3129:42;3176:3;3128:51;3093:86;3207:6;3197:16;;:21;3193:86;;3237:34;3229:42;3276:3;3228:51;3193:86;3307:7;3297:17;;:22;3293:86;;3338:33;3330:41;3376:3;3329:50;3293:86;3407:7;3397:17;;:22;3393:85;;3438:32;3430:40;3475:3;3429:49;3393:85;3506:7;3496:17;;:22;3492:83;;3537:30;3529:38;3572:3;3528:47;3492:83;3603:7;3593:17;;:22;3589:78;;3634:25;3626:33;3664:3;3625:42;3589:78;3693:1;3686:4;:8;;;3682:47;;;3724:5;3704:17;:25;;;;;:::i;:::-;;3696:33;;3682:47;4104:7;4095:5;:17;:22;:30;;4124:1;4095:30;;;4120:1;4095:30;4078:48;;4088:2;4079:5;:11;;4078:48;4055:72;;1480:2658;;1385:2759;;;:::o;741:4127:21:-;853:14;;;1419:6;1416:1;1413;1406:20;1459:1;1456;1452:9;1443:18;;1514:5;1510:2;1507:13;1499:5;1495:2;1491:14;1487:34;1478:43;;;1615:5;1624:1;1615:10;1611:203;;1667:1;1653:11;:15;1645:24;;;;;;-1:-1:-1;1728:23:21;;;;-1:-1:-1;1786:13:21;;1611:203;1953:5;1939:11;:19;1931:28;;;;;;2260:17;2344:11;2341:1;2338;2331:25;2736:12;2752:15;;;2751:31;;2888:22;;;;;3763:1;3744;:15;;3743:21;;4006:17;;;4002:21;;3995:28;4068:17;;;4064:21;;4057:28;4131:17;;;4127:21;;4120:28;4194:17;;;4190:21;;4183:28;4257:17;;;4253:21;;4246:28;4321:17;;;4317:21;;;4310:28;3300:12;;;;3296:23;;;3321:1;3292:31;2489:20;;;2478:32;;;3359:12;;;;2536:21;;;;3032:16;;;;3350:21;;;;4813:11;;;;;-1:-1:-1;;741:4127:21;;;;;:::o;14:154:25:-;100:42;93:5;89:54;82:5;79:65;69:93;;158:1;155;148:12;69:93;14:154;:::o;173:388::-;241:6;249;302:2;290:9;281:7;277:23;273:32;270:52;;;318:1;315;308:12;270:52;357:9;344:23;376:31;401:5;376:31;:::i;:::-;426:5;-1:-1:-1;483:2:25;468:18;;455:32;496:33;455:32;496:33;:::i;:::-;548:7;538:17;;;173:388;;;;;:::o;1247:188::-;1315:20;;1375:34;1364:46;;1354:57;;1344:85;;1425:1;1422;1415:12;1344:85;1247:188;;;:::o;1440:163::-;1507:20;;1567:10;1556:22;;1546:33;;1536:61;;1593:1;1590;1583:12;1608:535;1693:6;1701;1709;1717;1770:3;1758:9;1749:7;1745:23;1741:33;1738:53;;;1787:1;1784;1777:12;1738:53;1810:29;1829:9;1810:29;:::i;:::-;1800:39;;1889:2;1878:9;1874:18;1861:32;1902:31;1927:5;1902:31;:::i;:::-;1952:5;-1:-1:-1;2009:2:25;1994:18;;1981:32;2022:33;1981:32;2022:33;:::i;:::-;2074:7;-1:-1:-1;2100:37:25;2133:2;2118:18;;2100:37;:::i;:::-;2090:47;;1608:535;;;;;;;:::o;2330:456::-;2407:6;2415;2423;2476:2;2464:9;2455:7;2451:23;2447:32;2444:52;;;2492:1;2489;2482:12;2444:52;2531:9;2518:23;2550:31;2575:5;2550:31;:::i;:::-;2600:5;-1:-1:-1;2657:2:25;2642:18;;2629:32;2670:33;2629:32;2670:33;:::i;:::-;2330:456;;2722:7;;-1:-1:-1;;;2776:2:25;2761:18;;;;2748:32;;2330:456::o;3196:604::-;3290:6;3298;3306;3314;3322;3375:3;3363:9;3354:7;3350:23;3346:33;3343:53;;;3392:1;3389;3382:12;3343:53;3415:29;3434:9;3415:29;:::i;:::-;3405:39;;3494:2;3483:9;3479:18;3466:32;3507:31;3532:5;3507:31;:::i;:::-;3557:5;-1:-1:-1;3614:2:25;3599:18;;3586:32;3627:33;3586:32;3627:33;:::i;:::-;3679:7;-1:-1:-1;3705:37:25;3738:2;3723:18;;3705:37;:::i;:::-;3196:604;;;;-1:-1:-1;3196:604:25;;3789:3;3774:19;3761:33;;3196:604;-1:-1:-1;;3196:604:25:o;3805:184::-;3857:77;3854:1;3847:88;3954:4;3951:1;3944:15;3978:4;3975:1;3968:15;3994:125;4059:9;;;4080:10;;;4077:36;;;4093:18;;:::i;:::-;3994:125;;;;:::o;4124:184::-;4176:77;4173:1;4166:88;4273:4;4270:1;4263:15;4297:4;4294:1;4287:15;4643:184;4695:77;4692:1;4685:88;4792:4;4789:1;4782:15;4816:4;4813:1;4806:15;4832:647;5001:2;5053:21;;;5123:13;;5026:18;;;5145:22;;;4972:4;;5001:2;5224:15;;;;5198:2;5183:18;;;4972:4;5267:186;5281:6;5278:1;5275:13;5267:186;;;5346:13;;5361:10;5342:30;5330:43;;5428:15;;;;5393:12;;;;5303:1;5296:9;5267:186;;;-1:-1:-1;5470:3:25;;4832:647;-1:-1:-1;;;;;;4832:647:25:o;5484:334::-;5555:2;5549:9;5611:2;5601:13;;5616:66;5597:86;5585:99;;5714:18;5699:34;;5735:22;;;5696:62;5693:88;;;5761:18;;:::i;:::-;5797:2;5790:22;5484:334;;-1:-1:-1;5484:334:25:o;5823:181::-;5881:4;5914:18;5906:6;5903:30;5900:56;;;5936:18;;:::i;:::-;-1:-1:-1;5981:1:25;5977:14;5993:4;5973:25;;5823:181::o;6009:732::-;6074:5;6127:3;6120:4;6112:6;6108:17;6104:27;6094:55;;6145:1;6142;6135:12;6094:55;6174:6;6168:13;6200:4;6224:58;6240:41;6278:2;6240:41;:::i;:::-;6224:58;:::i;:::-;6316:15;;;6402:1;6398:10;;;;6386:23;;6382:32;;;6347:12;;;;6426:15;;;6423:35;;;6454:1;6451;6444:12;6423:35;6490:2;6482:6;6478:15;6502:210;6518:6;6513:3;6510:15;6502:210;;;6591:3;6585:10;6608:31;6633:5;6608:31;:::i;:::-;6652:18;;6690:12;;;;6535;;6502:210;;;-1:-1:-1;6730:5:25;6009:732;-1:-1:-1;;;;;;6009:732:25:o;6746:1303::-;6873:6;6881;6934:2;6922:9;6913:7;6909:23;6905:32;6902:52;;;6950:1;6947;6940:12;6902:52;6983:9;6977:16;7012:18;7053:2;7045:6;7042:14;7039:34;;;7069:1;7066;7059:12;7039:34;7107:6;7096:9;7092:22;7082:32;;7152:7;7145:4;7141:2;7137:13;7133:27;7123:55;;7174:1;7171;7164:12;7123:55;7203:2;7197:9;7225:4;7249:58;7265:41;7303:2;7265:41;:::i;7249:58::-;7341:15;;;7423:1;7419:10;;;;7411:19;;7407:28;;;7372:12;;;;7447:19;;;7444:39;;;7479:1;7476;7469:12;7444:39;7503:11;;;;7523:308;7539:6;7534:3;7531:15;7523:308;;;7612:3;7606:10;7663:5;7660:1;7649:20;7642:5;7639:31;7629:129;;7712:1;7741:2;7737;7730:14;7629:129;7771:18;;7556:12;;;;7809;;;;7523:308;;;7886:18;;;7880:25;7850:5;;-1:-1:-1;7880:25:25;;-1:-1:-1;;;7917:16:25;;;7914:36;;;7946:1;7943;7936:12;7914:36;;7969:74;8035:7;8024:8;8013:9;8009:24;7969:74;:::i;:::-;7959:84;;;6746:1303;;;;;:::o;8054:255::-;8152:1;8141:16;;;8123;;;;8119:39;8183:66;8173:77;;8262:16;8252:27;;8170:110;8167:136;;;8283:18;;:::i;8314:184::-;8366:77;8363:1;8356:88;8463:4;8460:1;8453:15;8487:4;8484:1;8477:15;8503:389;8541:1;8582;8579;8568:16;8618:1;8615;8604:16;8639:3;8629:37;;8646:18;;:::i;:::-;8767:66;8762:3;8759:75;8690:66;8685:3;8682:75;8678:157;8675:183;;;8838:18;;:::i;:::-;8872:14;;;8503:389;-1:-1:-1;;;8503:389:25:o;8897:166::-;8927:1;8968;8965;8954:16;8989:3;8979:37;;8996:18;;:::i;:::-;9053:3;9049:1;9046;9035:16;9030:27;9025:32;;;8897:166;;;;:::o;9068:306::-;9105:3;9152:5;9149:1;9138:20;9182:66;9173:7;9170:79;9167:105;;9252:18;;:::i;:::-;9301:66;9288:80;;9068:306;-1:-1:-1;;9068:306:25:o;9379:228::-;9419:7;9545:1;9477:66;9473:74;9470:1;9467:81;9462:1;9455:9;9448:17;9444:105;9441:131;;;9552:18;;:::i;:::-;-1:-1:-1;9592:9:25;;9379:228::o;10624:412::-;10753:3;10791:6;10785:13;10816:1;10826:129;10840:6;10837:1;10834:13;10826:129;;;10938:4;10922:14;;;10918:25;;10912:32;10899:11;;;10892:53;10855:12;10826:129;;;-1:-1:-1;11010:1:25;10974:16;;10999:13;;;-1:-1:-1;10974:16:25;10624:412;-1:-1:-1;10624:412:25:o;11041:208::-;11110:42;11185:10;;;11173;;;11169:27;;11208:12;;;11205:38;;;11223:18;;:::i;:::-;11205:38;11041:208;;;;:::o;11254:303::-;11294:7;11326:50;11403:2;11400:1;11396:10;11433:2;11430:1;11426:10;11489:3;11485:2;11481:12;11476:3;11473:21;11466:3;11459:11;11452:19;11448:47;11445:73;;;11498:18;;:::i;:::-;11538:13;;11254:303;-1:-1:-1;;;;11254:303:25:o;11562:232::-;11602:1;11628:50;11705:2;11702:1;11698:10;11727:3;11717:37;;11734:18;;:::i;:::-;11772:10;;11768:20;;;;;11562:232;-1:-1:-1;;11562:232:25:o",
    linkReferences: {},
    immutableReferences: {
      "28": [
        {
          start: 228,
          length: 32
        },
        {
          start: 1308,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "getPool(address,address)": "531aa03e",
    "getQuote(uint128,address,address,uint32)": "63711362",
    "getQuoteAndUpdatePool(uint128,address,address,uint32,uint256)": "cb41861d",
    "getUpdatedPool(address,address,uint256)": "6cd62fb3",
    "pools(address,address)": "901754d7",
    "uniswapV3Factory()": "5b549182",
    "updatePool(address,address)": "80e1ed82"
  },
  rawMetadata:
    '{"compiler":{"version":"0.8.16+commit.07a7930e"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"uniswapV3Factory_","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"T","type":"error"},{"anonymous":false,"inputs":[{"components":[{"internalType":"address","name":"poolAddress","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint48","name":"lastUpdatedTimestamp","type":"uint48"}],"indexed":false,"internalType":"struct PoolData","name":"pool","type":"tuple"}],"name":"PoolUpdated","type":"event"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"}],"name":"getPool","outputs":[{"components":[{"internalType":"address","name":"poolAddress","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint48","name":"lastUpdatedTimestamp","type":"uint48"}],"internalType":"struct PoolData","name":"pool","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint128","name":"baseAmount","type":"uint128"},{"internalType":"address","name":"baseToken","type":"address"},{"internalType":"address","name":"quoteToken","type":"address"},{"internalType":"uint32","name":"secondsAgo","type":"uint32"}],"name":"getQuote","outputs":[{"internalType":"uint256","name":"quoteAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint128","name":"baseAmount","type":"uint128"},{"internalType":"address","name":"baseToken","type":"address"},{"internalType":"address","name":"quoteToken","type":"address"},{"internalType":"uint32","name":"secondsAgo","type":"uint32"},{"internalType":"uint256","name":"updateInterval","type":"uint256"}],"name":"getQuoteAndUpdatePool","outputs":[{"internalType":"uint256","name":"quoteAmount","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"updateInterval","type":"uint256"}],"name":"getUpdatedPool","outputs":[{"components":[{"internalType":"address","name":"poolAddress","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint48","name":"lastUpdatedTimestamp","type":"uint48"}],"internalType":"struct PoolData","name":"pool","type":"tuple"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"pools","outputs":[{"internalType":"address","name":"poolAddress","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint48","name":"lastUpdatedTimestamp","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapV3Factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"}],"name":"updatePool","outputs":[{"components":[{"internalType":"address","name":"poolAddress","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint48","name":"lastUpdatedTimestamp","type":"uint48"}],"internalType":"struct PoolData","name":"highestLiquidityPool","type":"tuple"}],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"author":"jacopo.eth <jacopo@slice.so>","kind":"dev","methods":{"getPool(address,address)":{"params":{"tokenA":"Address of one of the ERC20 token contract in the pool","tokenB":"Address of the other ERC20 token contract in the pool"},"returns":{"pool":"address, fee and last edit timestamp."}},"getQuote(uint128,address,address,uint32)":{"params":{"baseAmount":"Amount of token to be converted","baseToken":"Address of an ERC20 token contract used as the baseAmount denomination","quoteToken":"Address of an ERC20 token contract used as the quoteAmount denomination","secondsAgo":"Number of seconds in the past from which to calculate the time-weighted quote"},"returns":{"quoteAmount":"Equivalent amount of ERC20 token for baseAmount"}},"getQuoteAndUpdatePool(uint128,address,address,uint32,uint256)":{"params":{"baseAmount":"Amount of token to be converted","baseToken":"Address of an ERC20 token contract used as the baseAmount denomination","quoteToken":"Address of an ERC20 token contract used as the quoteAmount denomination","secondsAgo":"Number of seconds in the past from which to calculate the time-weighted quote","updateInterval":"Seconds after which a pool is considered stale and an update is triggered"},"returns":{"quoteAmount":"Equivalent amount of ERC20 token for baseAmount Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool has not been stored yet."}},"getUpdatedPool(address,address,uint256)":{"params":{"tokenA":"Address of one of the ERC20 token contract in the pool","tokenB":"Address of the other ERC20 token contract in the pool","updateInterval":"Seconds after which a pool is considered stale and an update is triggered"},"returns":{"pool":"address, fee and last edit timestamp. Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool has not been stored yet."}},"updatePool(address,address)":{"params":{"tokenA":"Address of one of the ERC20 token contract in the pool","tokenB":"Address of the other ERC20 token contract in the pool"},"returns":{"highestLiquidityPool":"Pool with the highest harmonicMeanLiquidity"}}},"title":"PriceFeed","version":1},"userdoc":{"events":{"PoolUpdated((address,uint24,uint48))":{"notice":"Emitted when a pool is updated"}},"kind":"user","methods":{"constructor":{"notice":"================================= ========== Constructor ========== ================================="},"getPool(address,address)":{"notice":"Retrieves pool given tokenA and tokenB, regardless of order."},"getQuote(uint128,address,address,uint32)":{"notice":"Get the time-weighted quote of `quoteToken` received in exchange for a `baseAmount` of `baseToken`, from the pool with highest liquidity, based on a `secondsAgo` twap interval. Requirement: secondsAgo must be greater than 0."},"getQuoteAndUpdatePool(uint128,address,address,uint32,uint256)":{"notice":"Get the time-weighted quote of `quoteToken`, and updates the pool in case there is no pool stored."},"getUpdatedPool(address,address,uint256)":{"notice":"Retrieves pool given tokenA and tokenB, regardless of order, and updates pool if necessary."},"pools(address,address)":{"notice":"Mapping from currency to PoolData"},"updatePool(address,address)":{"notice":"Updates stored pool with the one having the highest liquidity."}},"notice":"General purpose price feed based on Uniswap V3.","version":1}},"settings":{"compilationTarget":{"contracts/PriceFeed.sol":"PriceFeed"},"evmVersion":"london","libraries":{},"metadata":{"bytecodeHash":"none"},"optimizer":{"enabled":true,"runs":1000000},"remappings":[":@uniswap/v3-core/=lib/v3-core/",":@uniswap/v3-periphery/=lib/v3-periphery/",":create3-factory/=lib/create3-factory/src/",":ds-test/=lib/ds-test/src/",":forge-std/=lib/forge-std/src/",":openzeppelin-contracts/=lib/openzeppelin-contracts/contracts/",":prb-math/=lib/prb-math/contracts/",":solmate/=lib/solmate/src/",":v3-core/=lib/v3-core/contracts/",":v3-periphery/=lib/v3-periphery/contracts/"]},"sources":{"contracts/PriceFeed.sol":{"keccak256":"0x22fd78179fb9ec83758d6e926b6de96fb8f17deb47865c548138f6d25abfcf35","license":"MIT","urls":["bzz-raw://308c347ee4e6620d6514de9fe57d5402069921d96024c88262656f37419cd2f2","dweb:/ipfs/QmRGokEVDQPtyUa4CiKGArXi39d843BT36GMuCojBkTjw3"]},"contracts/interfaces/IPriceFeed.sol":{"keccak256":"0xb4e501319f32e15f2aedd4eaf3ca779fb2333bd70c40427d01caa2733ed40f91","license":"MIT","urls":["bzz-raw://539c50bc077964766bc6cf8459418a58ff9adc1818aad57056ad115902714d96","dweb:/ipfs/QmY67p8s3AR3VNAQXBLEPGAVXGpYPWMywVKwbqfQbSXXRk"]},"contracts/structs/PoolData.sol":{"keccak256":"0x79a67ac11a630d245510b88ea0be8c8515a590605546583d56598a9b2f10cecd","license":"MIT","urls":["bzz-raw://44d7fcfb21f1da90ff46fbb23c7217a71c5f6a56c8f03c2ed9157bddb47008ed","dweb:/ipfs/QmNfsVCr9kF8Fu469oJdq3mga6gG7Gp3X2fAxTTnTx49SF"]},"contracts/utils/PoolAddress.sol":{"keccak256":"0x70d20030b317b5090f754bb8212c5a69a9ffa20bf63c2632d3311e4b12352865","license":"GPL-2.0-or-later","urls":["bzz-raw://964e257bc14b5b09b9cc9522742b4d379fae11a7b61535dde361b9c096698894","dweb:/ipfs/QmeFpakrk8Aut2jtyrpLzk9Evk5DbKS5nnpnNxswUwyomo"]},"lib/v3-core/contracts/interfaces/IUniswapV3Pool.sol":{"keccak256":"0x4e64844c56061cd90e0a80de73534a9166704c43eed579eb83f90bc2780ce968","license":"GPL-2.0-or-later","urls":["bzz-raw://cba4fab5cebdddf644b901994a7f0f52b98885d4c56012f4dc51d52c2bf9de0e","dweb:/ipfs/QmVyyrRmqXrAiapewWunRVgiPVFJHpH2hKiE1py1svMSNV"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolActions.sol":{"keccak256":"0x9453dd0e7442188667d01d9b65de3f1e14e9511ff3e303179a15f6fc267f7634","license":"GPL-2.0-or-later","urls":["bzz-raw://982f4328f956c3e60e67501e759eb292ac487f76460c774c50e9ae4fcc92aae5","dweb:/ipfs/QmRnzEDsaqtd9PJEVcgQi7p5aV5pMSvRUoGZJAdwFUJxgZ"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolDerivedState.sol":{"keccak256":"0xe603ac5b17ecdee73ba2b27efdf386c257a19c14206e87eee77e2017b742d9e5","license":"GPL-2.0-or-later","urls":["bzz-raw://8febc9bdb399a4d94bb89f5377732652e2400e4a8dee808201ade6848f9004e7","dweb:/ipfs/QmaKDqYYFU4d2W2iN77aDHptfbFmYZRrMYXHeGpJmM8C1c"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolErrors.sol":{"keccak256":"0xf80abf13fb1fafc127ba4e792f240dd8ea7c8c893978cdfd8439c27fae9a037b","license":"GPL-2.0-or-later","urls":["bzz-raw://b04fc72a656bbf3631e9c2e67b9870a2d9d235185e833fe050e9606e6816a9aa","dweb:/ipfs/QmUcz4bkEkJ9pwzFu1C3n97hBQ3st9U6qTAqCdyFwddKco"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolEvents.sol":{"keccak256":"0x8071514d0fe5d17d6fbd31c191cdfb703031c24e0ece3621d88ab10e871375cd","license":"GPL-2.0-or-later","urls":["bzz-raw://d0b571930cc7488b1d546a7e9cea7c52d8b3c4e207da657ed0e0db7343b8cd03","dweb:/ipfs/QmaGK6vVwB95QSTR1XMYvrh7ivYAYZxi3fD7v6VMA4jZ39"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolImmutables.sol":{"keccak256":"0xf6e5d2cd1139c4c276bdbc8e1d2b256e456c866a91f1b868da265c6d2685c3f7","license":"GPL-2.0-or-later","urls":["bzz-raw://b99c8c9ae8e27ee6559e5866bea82cbc9ffc8247f8d15b7422a4deb287d4d047","dweb:/ipfs/QmfL8gaqt3ffAnm6nVj5ksuNpLygXuL3xq5VBqrkwC2JJ3"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolOwnerActions.sol":{"keccak256":"0x759b78a2918af9e99e246dc3af084f654e48ef32bb4e4cb8a966aa3dcaece235","license":"GPL-2.0-or-later","urls":["bzz-raw://64144fb96e1c7fdba87305acadb98a198d26a3d46c097cb3a666e567f6f29735","dweb:/ipfs/QmUnWVwN9FKB9uV5Pr8YfLpWZnYM2DENnRMaadZ492JS9u"]},"lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolState.sol":{"keccak256":"0x44fa2ce1182f6c2f6bead3d1737804bf7e112252ae86e0f2e92f9b8249603f43","license":"GPL-2.0-or-later","urls":["bzz-raw://54154e8665b98d65f5dc91b256551852cb47882180b501b260657122d207c0ea","dweb:/ipfs/QmcfemK1A2PXYrWB5SBFGERpMCderbFRb8BtTzQDj1sUBp"]},"lib/v3-core/contracts/libraries/FullMath.sol":{"keccak256":"0x7825565a4bb2a34a1dc96bbfead755785dfb0df8ef81bd934c43023689685645","license":"MIT","urls":["bzz-raw://8f44f4614d31e3d4864c7eb13620555253b84f6a69180f8745b7c6e246a9d125","dweb:/ipfs/QmfNQUcXj3KL8h9u5PqbtEC6yRtwDbKNb48uMPjdwxsKnd"]},"lib/v3-core/contracts/libraries/TickMath.sol":{"keccak256":"0x5c57de03a91cc2ec8939865dbbcb0197bb6c353b711075eefd8e0fca5e102129","license":"GPL-2.0-or-later","urls":["bzz-raw://1e994c24fd891ef8a3f5dbf5eba42b34feaf05e0376a29f91322faa18054449c","dweb:/ipfs/QmNdUJGUQxd1dPkMbnA5f5UNqakxRkQE5r7bTZJAuHeapS"]},"lib/v3-periphery/contracts/libraries/OracleLibrary.sol":{"keccak256":"0xe313f89c69c0f1c91f0722868313b4ceb14479b3e7a0abf52a1b9bbd9c18e81b","license":"GPL-2.0-or-later","urls":["bzz-raw://8ad09b061f3f533c116618c20cf01510108eebebb7ff8847b0f245b8ba368d53","dweb:/ipfs/QmU6vdi5JjJfjK2KqonWvRg9NeuQWarj4B1YFN22Dh9VJM"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.16+commit.07a7930e"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "uniswapV3Factory_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [],
          type: "error",
          name: "T"
        },
        {
          inputs: [
            {
              internalType: "struct PoolData",
              name: "pool",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "poolAddress",
                  type: "address"
                },
                {
                  internalType: "uint24",
                  name: "fee",
                  type: "uint24"
                },
                {
                  internalType: "uint48",
                  name: "lastUpdatedTimestamp",
                  type: "uint48"
                }
              ],
              indexed: false
            }
          ],
          type: "event",
          name: "PoolUpdated",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "tokenA",
              type: "address"
            },
            {
              internalType: "address",
              name: "tokenB",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getPool",
          outputs: [
            {
              internalType: "struct PoolData",
              name: "pool",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "poolAddress",
                  type: "address"
                },
                {
                  internalType: "uint24",
                  name: "fee",
                  type: "uint24"
                },
                {
                  internalType: "uint48",
                  name: "lastUpdatedTimestamp",
                  type: "uint48"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint128",
              name: "baseAmount",
              type: "uint128"
            },
            {
              internalType: "address",
              name: "baseToken",
              type: "address"
            },
            {
              internalType: "address",
              name: "quoteToken",
              type: "address"
            },
            {
              internalType: "uint32",
              name: "secondsAgo",
              type: "uint32"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getQuote",
          outputs: [
            {
              internalType: "uint256",
              name: "quoteAmount",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint128",
              name: "baseAmount",
              type: "uint128"
            },
            {
              internalType: "address",
              name: "baseToken",
              type: "address"
            },
            {
              internalType: "address",
              name: "quoteToken",
              type: "address"
            },
            {
              internalType: "uint32",
              name: "secondsAgo",
              type: "uint32"
            },
            {
              internalType: "uint256",
              name: "updateInterval",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "getQuoteAndUpdatePool",
          outputs: [
            {
              internalType: "uint256",
              name: "quoteAmount",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "tokenA",
              type: "address"
            },
            {
              internalType: "address",
              name: "tokenB",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "updateInterval",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "getUpdatedPool",
          outputs: [
            {
              internalType: "struct PoolData",
              name: "pool",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "poolAddress",
                  type: "address"
                },
                {
                  internalType: "uint24",
                  name: "fee",
                  type: "uint24"
                },
                {
                  internalType: "uint48",
                  name: "lastUpdatedTimestamp",
                  type: "uint48"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "pools",
          outputs: [
            {
              internalType: "address",
              name: "poolAddress",
              type: "address"
            },
            {
              internalType: "uint24",
              name: "fee",
              type: "uint24"
            },
            {
              internalType: "uint48",
              name: "lastUpdatedTimestamp",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "uniswapV3Factory",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "tokenA",
              type: "address"
            },
            {
              internalType: "address",
              name: "tokenB",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "updatePool",
          outputs: [
            {
              internalType: "struct PoolData",
              name: "highestLiquidityPool",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "poolAddress",
                  type: "address"
                },
                {
                  internalType: "uint24",
                  name: "fee",
                  type: "uint24"
                },
                {
                  internalType: "uint48",
                  name: "lastUpdatedTimestamp",
                  type: "uint48"
                }
              ]
            }
          ]
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {
          "getPool(address,address)": {
            params: {
              tokenA: "Address of one of the ERC20 token contract in the pool",
              tokenB: "Address of the other ERC20 token contract in the pool"
            },
            returns: {
              pool: "address, fee and last edit timestamp."
            }
          },
          "getQuote(uint128,address,address,uint32)": {
            params: {
              baseAmount: "Amount of token to be converted",
              baseToken:
                "Address of an ERC20 token contract used as the baseAmount denomination",
              quoteToken:
                "Address of an ERC20 token contract used as the quoteAmount denomination",
              secondsAgo:
                "Number of seconds in the past from which to calculate the time-weighted quote"
            },
            returns: {
              quoteAmount: "Equivalent amount of ERC20 token for baseAmount"
            }
          },
          "getQuoteAndUpdatePool(uint128,address,address,uint32,uint256)": {
            params: {
              baseAmount: "Amount of token to be converted",
              baseToken:
                "Address of an ERC20 token contract used as the baseAmount denomination",
              quoteToken:
                "Address of an ERC20 token contract used as the quoteAmount denomination",
              secondsAgo:
                "Number of seconds in the past from which to calculate the time-weighted quote",
              updateInterval:
                "Seconds after which a pool is considered stale and an update is triggered"
            },
            returns: {
              quoteAmount:
                "Equivalent amount of ERC20 token for baseAmount Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool has not been stored yet."
            }
          },
          "getUpdatedPool(address,address,uint256)": {
            params: {
              tokenA: "Address of one of the ERC20 token contract in the pool",
              tokenB: "Address of the other ERC20 token contract in the pool",
              updateInterval:
                "Seconds after which a pool is considered stale and an update is triggered"
            },
            returns: {
              pool: "address, fee and last edit timestamp. Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool has not been stored yet."
            }
          },
          "updatePool(address,address)": {
            params: {
              tokenA: "Address of one of the ERC20 token contract in the pool",
              tokenB: "Address of the other ERC20 token contract in the pool"
            },
            returns: {
              highestLiquidityPool:
                "Pool with the highest harmonicMeanLiquidity"
            }
          }
        },
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {
          constructor: {
            notice:
              "================================= ========== Constructor ========== ================================="
          },
          "getPool(address,address)": {
            notice:
              "Retrieves pool given tokenA and tokenB, regardless of order."
          },
          "getQuote(uint128,address,address,uint32)": {
            notice:
              "Get the time-weighted quote of `quoteToken` received in exchange for a `baseAmount` of `baseToken`, from the pool with highest liquidity, based on a `secondsAgo` twap interval. Requirement: secondsAgo must be greater than 0."
          },
          "getQuoteAndUpdatePool(uint128,address,address,uint32,uint256)": {
            notice:
              "Get the time-weighted quote of `quoteToken`, and updates the pool in case there is no pool stored."
          },
          "getUpdatedPool(address,address,uint256)": {
            notice:
              "Retrieves pool given tokenA and tokenB, regardless of order, and updates pool if necessary."
          },
          "pools(address,address)": {
            notice: "Mapping from currency to PoolData"
          },
          "updatePool(address,address)": {
            notice:
              "Updates stored pool with the one having the highest liquidity."
          }
        },
        version: 1
      }
    },
    settings: {
      remappings: [
        ":@uniswap/v3-core/=lib/v3-core/",
        ":@uniswap/v3-periphery/=lib/v3-periphery/",
        ":create3-factory/=lib/create3-factory/src/",
        ":ds-test/=lib/ds-test/src/",
        ":forge-std/=lib/forge-std/src/",
        ":openzeppelin-contracts/=lib/openzeppelin-contracts/contracts/",
        ":prb-math/=lib/prb-math/contracts/",
        ":solmate/=lib/solmate/src/",
        ":v3-core/=lib/v3-core/contracts/",
        ":v3-periphery/=lib/v3-periphery/contracts/"
      ],
      optimizer: {
        enabled: true,
        runs: 1000000
      },
      metadata: {
        bytecodeHash: "none"
      },
      compilationTarget: {
        "contracts/PriceFeed.sol": "PriceFeed"
      },
      libraries: {}
    },
    sources: {
      "contracts/PriceFeed.sol": {
        keccak256:
          "0x22fd78179fb9ec83758d6e926b6de96fb8f17deb47865c548138f6d25abfcf35",
        urls: [
          "bzz-raw://308c347ee4e6620d6514de9fe57d5402069921d96024c88262656f37419cd2f2",
          "dweb:/ipfs/QmRGokEVDQPtyUa4CiKGArXi39d843BT36GMuCojBkTjw3"
        ],
        license: "MIT"
      },
      "contracts/interfaces/IPriceFeed.sol": {
        keccak256:
          "0xb4e501319f32e15f2aedd4eaf3ca779fb2333bd70c40427d01caa2733ed40f91",
        urls: [
          "bzz-raw://539c50bc077964766bc6cf8459418a58ff9adc1818aad57056ad115902714d96",
          "dweb:/ipfs/QmY67p8s3AR3VNAQXBLEPGAVXGpYPWMywVKwbqfQbSXXRk"
        ],
        license: "MIT"
      },
      "contracts/structs/PoolData.sol": {
        keccak256:
          "0x79a67ac11a630d245510b88ea0be8c8515a590605546583d56598a9b2f10cecd",
        urls: [
          "bzz-raw://44d7fcfb21f1da90ff46fbb23c7217a71c5f6a56c8f03c2ed9157bddb47008ed",
          "dweb:/ipfs/QmNfsVCr9kF8Fu469oJdq3mga6gG7Gp3X2fAxTTnTx49SF"
        ],
        license: "MIT"
      },
      "contracts/utils/PoolAddress.sol": {
        keccak256:
          "0x70d20030b317b5090f754bb8212c5a69a9ffa20bf63c2632d3311e4b12352865",
        urls: [
          "bzz-raw://964e257bc14b5b09b9cc9522742b4d379fae11a7b61535dde361b9c096698894",
          "dweb:/ipfs/QmeFpakrk8Aut2jtyrpLzk9Evk5DbKS5nnpnNxswUwyomo"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/IUniswapV3Pool.sol": {
        keccak256:
          "0x4e64844c56061cd90e0a80de73534a9166704c43eed579eb83f90bc2780ce968",
        urls: [
          "bzz-raw://cba4fab5cebdddf644b901994a7f0f52b98885d4c56012f4dc51d52c2bf9de0e",
          "dweb:/ipfs/QmVyyrRmqXrAiapewWunRVgiPVFJHpH2hKiE1py1svMSNV"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolActions.sol": {
        keccak256:
          "0x9453dd0e7442188667d01d9b65de3f1e14e9511ff3e303179a15f6fc267f7634",
        urls: [
          "bzz-raw://982f4328f956c3e60e67501e759eb292ac487f76460c774c50e9ae4fcc92aae5",
          "dweb:/ipfs/QmRnzEDsaqtd9PJEVcgQi7p5aV5pMSvRUoGZJAdwFUJxgZ"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolDerivedState.sol": {
        keccak256:
          "0xe603ac5b17ecdee73ba2b27efdf386c257a19c14206e87eee77e2017b742d9e5",
        urls: [
          "bzz-raw://8febc9bdb399a4d94bb89f5377732652e2400e4a8dee808201ade6848f9004e7",
          "dweb:/ipfs/QmaKDqYYFU4d2W2iN77aDHptfbFmYZRrMYXHeGpJmM8C1c"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolErrors.sol": {
        keccak256:
          "0xf80abf13fb1fafc127ba4e792f240dd8ea7c8c893978cdfd8439c27fae9a037b",
        urls: [
          "bzz-raw://b04fc72a656bbf3631e9c2e67b9870a2d9d235185e833fe050e9606e6816a9aa",
          "dweb:/ipfs/QmUcz4bkEkJ9pwzFu1C3n97hBQ3st9U6qTAqCdyFwddKco"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolEvents.sol": {
        keccak256:
          "0x8071514d0fe5d17d6fbd31c191cdfb703031c24e0ece3621d88ab10e871375cd",
        urls: [
          "bzz-raw://d0b571930cc7488b1d546a7e9cea7c52d8b3c4e207da657ed0e0db7343b8cd03",
          "dweb:/ipfs/QmaGK6vVwB95QSTR1XMYvrh7ivYAYZxi3fD7v6VMA4jZ39"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolImmutables.sol": {
        keccak256:
          "0xf6e5d2cd1139c4c276bdbc8e1d2b256e456c866a91f1b868da265c6d2685c3f7",
        urls: [
          "bzz-raw://b99c8c9ae8e27ee6559e5866bea82cbc9ffc8247f8d15b7422a4deb287d4d047",
          "dweb:/ipfs/QmfL8gaqt3ffAnm6nVj5ksuNpLygXuL3xq5VBqrkwC2JJ3"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolOwnerActions.sol": {
        keccak256:
          "0x759b78a2918af9e99e246dc3af084f654e48ef32bb4e4cb8a966aa3dcaece235",
        urls: [
          "bzz-raw://64144fb96e1c7fdba87305acadb98a198d26a3d46c097cb3a666e567f6f29735",
          "dweb:/ipfs/QmUnWVwN9FKB9uV5Pr8YfLpWZnYM2DENnRMaadZ492JS9u"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/interfaces/pool/IUniswapV3PoolState.sol": {
        keccak256:
          "0x44fa2ce1182f6c2f6bead3d1737804bf7e112252ae86e0f2e92f9b8249603f43",
        urls: [
          "bzz-raw://54154e8665b98d65f5dc91b256551852cb47882180b501b260657122d207c0ea",
          "dweb:/ipfs/QmcfemK1A2PXYrWB5SBFGERpMCderbFRb8BtTzQDj1sUBp"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-core/contracts/libraries/FullMath.sol": {
        keccak256:
          "0x7825565a4bb2a34a1dc96bbfead755785dfb0df8ef81bd934c43023689685645",
        urls: [
          "bzz-raw://8f44f4614d31e3d4864c7eb13620555253b84f6a69180f8745b7c6e246a9d125",
          "dweb:/ipfs/QmfNQUcXj3KL8h9u5PqbtEC6yRtwDbKNb48uMPjdwxsKnd"
        ],
        license: "MIT"
      },
      "lib/v3-core/contracts/libraries/TickMath.sol": {
        keccak256:
          "0x5c57de03a91cc2ec8939865dbbcb0197bb6c353b711075eefd8e0fca5e102129",
        urls: [
          "bzz-raw://1e994c24fd891ef8a3f5dbf5eba42b34feaf05e0376a29f91322faa18054449c",
          "dweb:/ipfs/QmNdUJGUQxd1dPkMbnA5f5UNqakxRkQE5r7bTZJAuHeapS"
        ],
        license: "GPL-2.0-or-later"
      },
      "lib/v3-periphery/contracts/libraries/OracleLibrary.sol": {
        keccak256:
          "0xe313f89c69c0f1c91f0722868313b4ceb14479b3e7a0abf52a1b9bbd9c18e81b",
        urls: [
          "bzz-raw://8ad09b061f3f533c116618c20cf01510108eebebb7ff8847b0f245b8ba368d53",
          "dweb:/ipfs/QmU6vdi5JjJfjK2KqonWvRg9NeuQWarj4B1YFN22Dh9VJM"
        ],
        license: "GPL-2.0-or-later"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "contracts/PriceFeed.sol",
    id: 559,
    exportedSymbols: {
      IPriceFeed: [640],
      IUniswapV3Pool: [18552],
      OracleLibrary: [20341],
      PoolAddress: [746],
      PoolData: [649],
      PriceFeed: [558]
    },
    nodeType: "SourceUnit",
    src: "32:10269:0",
    nodes: [
      {
        id: 1,
        nodeType: "PragmaDirective",
        src: "32:24:0",
        literals: ["solidity", ">=", "0.8", ".0"]
      },
      {
        id: 2,
        nodeType: "ImportDirective",
        src: "58:37:0",
        absolutePath: "contracts/interfaces/IPriceFeed.sol",
        file: "./interfaces/IPriceFeed.sol",
        nameLocation: "-1:-1:-1",
        scope: 559,
        sourceUnit: 641,
        symbolAliases: [],
        unitAlias: ""
      },
      {
        id: 4,
        nodeType: "ImportDirective",
        src: "96:92:0",
        absolutePath: "lib/v3-periphery/contracts/libraries/OracleLibrary.sol",
        file: "@uniswap/v3-periphery/contracts/libraries/OracleLibrary.sol",
        nameLocation: "-1:-1:-1",
        scope: 559,
        sourceUnit: 20342,
        symbolAliases: [
          {
            foreign: {
              id: 3,
              name: "OracleLibrary",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 20341,
              src: "105:13:0",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 6,
        nodeType: "ImportDirective",
        src: "189:90:0",
        absolutePath: "lib/v3-core/contracts/interfaces/IUniswapV3Pool.sol",
        file: "@uniswap/v3-core/contracts/interfaces/IUniswapV3Pool.sol",
        nameLocation: "-1:-1:-1",
        scope: 559,
        sourceUnit: 18553,
        symbolAliases: [
          {
            foreign: {
              id: 5,
              name: "IUniswapV3Pool",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 18552,
              src: "198:14:0",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 8,
        nodeType: "ImportDirective",
        src: "280:54:0",
        absolutePath: "contracts/utils/PoolAddress.sol",
        file: "./utils/PoolAddress.sol",
        nameLocation: "-1:-1:-1",
        scope: 559,
        sourceUnit: 747,
        symbolAliases: [
          {
            foreign: {
              id: 7,
              name: "PoolAddress",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 746,
              src: "289:11:0",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 558,
        nodeType: "ContractDefinition",
        src: "466:9834:0",
        nodes: [
          {
            id: 17,
            nodeType: "EventDefinition",
            src: "661:33:0",
            anonymous: false,
            documentation: {
              id: 12,
              nodeType: "StructuredDocumentation",
              src: "624:34:0",
              text: "Emitted when a pool is updated"
            },
            eventSelector:
              "e04029824b233ce0ed16e01c61d0a4f69b7cca8564458765386e99179e0745bb",
            name: "PoolUpdated",
            nameLocation: "667:11:0",
            parameters: {
              id: 16,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 15,
                  indexed: false,
                  mutability: "mutable",
                  name: "pool",
                  nameLocation: "688:4:0",
                  nodeType: "VariableDeclaration",
                  scope: 17,
                  src: "679:13:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                    typeString: "struct PoolData"
                  },
                  typeName: {
                    id: 14,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 13,
                      name: "PoolData",
                      nameLocations: ["679:8:0"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 649,
                      src: "679:8:0"
                    },
                    referencedDeclaration: 649,
                    src: "679:8:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_storage_ptr",
                      typeString: "struct PoolData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "678:15:0"
            }
          },
          {
            id: 26,
            nodeType: "VariableDeclaration",
            src: "859:47:0",
            constant: false,
            documentation: {
              id: 18,
              nodeType: "StructuredDocumentation",
              src: "698:118:0",
              text: "=================================\n ======= Immutable Storage =======\n ================================="
            },
            mutability: "mutable",
            name: "fees",
            nameLocation: "876:4:0",
            scope: 558,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_array$_t_uint24_$dyn_storage",
              typeString: "uint24[]"
            },
            typeName: {
              baseType: {
                id: 19,
                name: "uint24",
                nodeType: "ElementaryTypeName",
                src: "859:6:0",
                typeDescriptions: {
                  typeIdentifier: "t_uint24",
                  typeString: "uint24"
                }
              },
              id: 20,
              nodeType: "ArrayTypeName",
              src: "859:8:0",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_uint24_$dyn_storage_ptr",
                typeString: "uint24[]"
              }
            },
            value: {
              components: [
                {
                  hexValue: "3130303030",
                  id: 21,
                  isConstant: false,
                  isLValue: false,
                  isPure: true,
                  kind: "number",
                  lValueRequested: false,
                  nodeType: "Literal",
                  src: "884:5:0",
                  typeDescriptions: {
                    typeIdentifier: "t_rational_10000_by_1",
                    typeString: "int_const 10000"
                  },
                  value: "10000"
                },
                {
                  hexValue: "33303030",
                  id: 22,
                  isConstant: false,
                  isLValue: false,
                  isPure: true,
                  kind: "number",
                  lValueRequested: false,
                  nodeType: "Literal",
                  src: "891:4:0",
                  typeDescriptions: {
                    typeIdentifier: "t_rational_3000_by_1",
                    typeString: "int_const 3000"
                  },
                  value: "3000"
                },
                {
                  hexValue: "353030",
                  id: 23,
                  isConstant: false,
                  isLValue: false,
                  isPure: true,
                  kind: "number",
                  lValueRequested: false,
                  nodeType: "Literal",
                  src: "897:3:0",
                  typeDescriptions: {
                    typeIdentifier: "t_rational_500_by_1",
                    typeString: "int_const 500"
                  },
                  value: "500"
                },
                {
                  hexValue: "313030",
                  id: 24,
                  isConstant: false,
                  isLValue: false,
                  isPure: true,
                  kind: "number",
                  lValueRequested: false,
                  nodeType: "Literal",
                  src: "902:3:0",
                  typeDescriptions: {
                    typeIdentifier: "t_rational_100_by_1",
                    typeString: "int_const 100"
                  },
                  value: "100"
                }
              ],
              id: 25,
              isConstant: false,
              isInlineArray: true,
              isLValue: false,
              isPure: true,
              lValueRequested: false,
              nodeType: "TupleExpression",
              src: "883:23:0",
              typeDescriptions: {
                typeIdentifier: "t_array$_t_uint16_$4_memory_ptr",
                typeString: "uint16[4] memory"
              }
            },
            visibility: "private"
          },
          {
            id: 28,
            nodeType: "VariableDeclaration",
            src: "949:41:0",
            baseFunctions: [566],
            constant: false,
            functionSelector: "5b549182",
            mutability: "immutable",
            name: "uniswapV3Factory",
            nameLocation: "974:16:0",
            scope: 558,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 27,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "949:7:0",
              stateMutability: "nonpayable",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            visibility: "public"
          },
          {
            id: 36,
            nodeType: "VariableDeclaration",
            src: "1156:61:0",
            baseFunctions: [579],
            constant: false,
            documentation: {
              id: 29,
              nodeType: "StructuredDocumentation",
              src: "1116:37:0",
              text: "Mapping from currency to PoolData"
            },
            functionSelector: "901754d7",
            mutability: "mutable",
            name: "pools",
            nameLocation: "1212:5:0",
            scope: 558,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier:
                "t_mapping$_t_address_$_t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$_$",
              typeString:
                "mapping(address => mapping(address => struct PoolData))"
            },
            typeName: {
              id: 35,
              keyType: {
                id: 30,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "1164:7:0",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                }
              },
              nodeType: "Mapping",
              src: "1156:48:0",
              typeDescriptions: {
                typeIdentifier:
                  "t_mapping$_t_address_$_t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$_$",
                typeString:
                  "mapping(address => mapping(address => struct PoolData))"
              },
              valueType: {
                id: 34,
                keyType: {
                  id: 31,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "1183:7:0",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                nodeType: "Mapping",
                src: "1175:28:0",
                typeDescriptions: {
                  typeIdentifier:
                    "t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$",
                  typeString: "mapping(address => struct PoolData)"
                },
                valueType: {
                  id: 33,
                  nodeType: "UserDefinedTypeName",
                  pathNode: {
                    id: 32,
                    name: "PoolData",
                    nameLocations: ["1194:8:0"],
                    nodeType: "IdentifierPath",
                    referencedDeclaration: 649,
                    src: "1194:8:0"
                  },
                  referencedDeclaration: 649,
                  src: "1194:8:0",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PoolData_$649_storage_ptr",
                    typeString: "struct PoolData"
                  }
                }
              }
            },
            visibility: "public"
          },
          {
            id: 47,
            nodeType: "FunctionDefinition",
            src: "1343:86:0",
            body: {
              id: 46,
              nodeType: "Block",
              src: "1382:47:0",
              statements: [
                {
                  expression: {
                    id: 44,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 42,
                      name: "uniswapV3Factory",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 28,
                      src: "1388:16:0",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 43,
                      name: "uniswapV3Factory_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 39,
                      src: "1407:17:0",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "1388:36:0",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 45,
                  nodeType: "ExpressionStatement",
                  src: "1388:36:0"
                }
              ]
            },
            documentation: {
              id: 37,
              nodeType: "StructuredDocumentation",
              src: "1222:118:0",
              text: "=================================\n ========== Constructor ==========\n ================================="
            },
            implemented: true,
            kind: "constructor",
            modifiers: [],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 40,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 39,
                  mutability: "mutable",
                  name: "uniswapV3Factory_",
                  nameLocation: "1363:17:0",
                  nodeType: "VariableDeclaration",
                  scope: 47,
                  src: "1355:25:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 38,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1355:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1354:27:0"
            },
            returnParameters: {
              id: 41,
              nodeType: "ParameterList",
              parameters: [],
              src: "1382:0:0"
            },
            scope: 558,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 82,
            nodeType: "FunctionDefinition",
            src: "1838:252:0",
            body: {
              id: 81,
              nodeType: "Block",
              src: "1944:146:0",
              statements: [
                {
                  assignments: [59, 61],
                  declarations: [
                    {
                      constant: false,
                      id: 59,
                      mutability: "mutable",
                      name: "token0",
                      nameLocation: "1959:6:0",
                      nodeType: "VariableDeclaration",
                      scope: 81,
                      src: "1951:14:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 58,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "1951:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 61,
                      mutability: "mutable",
                      name: "token1",
                      nameLocation: "1975:6:0",
                      nodeType: "VariableDeclaration",
                      scope: 81,
                      src: "1967:14:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 60,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "1967:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 72,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 64,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 62,
                        name: "tokenA",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 50,
                        src: "1985:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<",
                      rightExpression: {
                        id: 63,
                        name: "tokenB",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 52,
                        src: "1994:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "1985:15:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      components: [
                        {
                          id: 68,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 52,
                          src: "2035:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 69,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 50,
                          src: "2043:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      id: 70,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "TupleExpression",
                      src: "2034:16:0",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                        typeString: "tuple(address,address)"
                      }
                    },
                    id: 71,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "1985:65:0",
                    trueExpression: {
                      components: [
                        {
                          id: 65,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 50,
                          src: "2010:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 66,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 52,
                          src: "2018:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      id: 67,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "TupleExpression",
                      src: "2009:16:0",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                        typeString: "tuple(address,address)"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                      typeString: "tuple(address,address)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1950:100:0"
                },
                {
                  expression: {
                    id: 79,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 73,
                      name: "pool",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56,
                      src: "2057:4:0",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      baseExpression: {
                        baseExpression: {
                          id: 74,
                          name: "pools",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 36,
                          src: "2064:5:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_mapping$_t_address_$_t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$_$",
                            typeString:
                              "mapping(address => mapping(address => struct PoolData storage ref))"
                          }
                        },
                        id: 76,
                        indexExpression: {
                          id: 75,
                          name: "token0",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 59,
                          src: "2070:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "2064:13:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$",
                          typeString:
                            "mapping(address => struct PoolData storage ref)"
                        }
                      },
                      id: 78,
                      indexExpression: {
                        id: 77,
                        name: "token1",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 61,
                        src: "2078:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "2064:21:0",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_storage",
                        typeString: "struct PoolData storage ref"
                      }
                    },
                    src: "2057:28:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                      typeString: "struct PoolData memory"
                    }
                  },
                  id: 80,
                  nodeType: "ExpressionStatement",
                  src: "2057:28:0"
                }
              ]
            },
            baseFunctions: [589],
            documentation: {
              id: 48,
              nodeType: "StructuredDocumentation",
              src: "1554:281:0",
              text: "@notice Retrieves pool given tokenA and tokenB, regardless of order.\n @param tokenA Address of one of the ERC20 token contract in the pool\n @param tokenB Address of the other ERC20 token contract in the pool\n @return pool address, fee and last edit timestamp."
            },
            functionSelector: "531aa03e",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getPool",
            nameLocation: "1847:7:0",
            parameters: {
              id: 53,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 50,
                  mutability: "mutable",
                  name: "tokenA",
                  nameLocation: "1863:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 82,
                  src: "1855:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 49,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1855:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 52,
                  mutability: "mutable",
                  name: "tokenB",
                  nameLocation: "1879:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 82,
                  src: "1871:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 51,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1871:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1854:32:0"
            },
            returnParameters: {
              id: 57,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 56,
                  mutability: "mutable",
                  name: "pool",
                  nameLocation: "1936:4:0",
                  nodeType: "VariableDeclaration",
                  scope: 82,
                  src: "1920:20:0",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                    typeString: "struct PoolData"
                  },
                  typeName: {
                    id: 55,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 54,
                      name: "PoolData",
                      nameLocations: ["1920:8:0"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 649,
                      src: "1920:8:0"
                    },
                    referencedDeclaration: 649,
                    src: "1920:8:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_storage_ptr",
                      typeString: "struct PoolData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1919:22:0"
            },
            scope: 558,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 130,
            nodeType: "FunctionDefinition",
            src: "2766:484:0",
            body: {
              id: 129,
              nodeType: "Block",
              src: "2924:326:0",
              statements: [
                {
                  assignments: [97],
                  declarations: [
                    {
                      constant: false,
                      id: 97,
                      mutability: "mutable",
                      name: "pool",
                      nameLocation: "2938:4:0",
                      nodeType: "VariableDeclaration",
                      scope: 129,
                      src: "2930:12:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 96,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "2930:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 103,
                  initialValue: {
                    expression: {
                      arguments: [
                        {
                          id: 99,
                          name: "baseToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87,
                          src: "2953:9:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 100,
                          name: "quoteToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89,
                          src: "2964:10:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 98,
                        name: "getPool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "2945:7:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_view$_t_address_$_t_address_$returns$_t_struct$_PoolData_$649_memory_ptr_$",
                          typeString:
                            "function (address,address) view returns (struct PoolData memory)"
                        }
                      },
                      id: 101,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2945:30:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    id: 102,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "2976:11:0",
                    memberName: "poolAddress",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 644,
                    src: "2945:42:0",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2930:57:0"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 109,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 104,
                      name: "pool",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 97,
                      src: "2998:4:0",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 107,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "3014:1:0",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 106,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "3006:7:0",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 105,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "3006:7:0",
                          typeDescriptions: {}
                        }
                      },
                      id: 108,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3006:10:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "2998:18:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 128,
                  nodeType: "IfStatement",
                  src: "2994:252:0",
                  trueBody: {
                    id: 127,
                    nodeType: "Block",
                    src: "3018:228:0",
                    statements: [
                      {
                        assignments: [111],
                        declarations: [
                          {
                            constant: false,
                            id: 111,
                            mutability: "mutable",
                            name: "arithmeticMeanTick",
                            nameLocation: "3032:18:0",
                            nodeType: "VariableDeclaration",
                            scope: 127,
                            src: "3026:24:0",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_int24",
                              typeString: "int24"
                            },
                            typeName: {
                              id: 110,
                              name: "int24",
                              nodeType: "ElementaryTypeName",
                              src: "3026:5:0",
                              typeDescriptions: {
                                typeIdentifier: "t_int24",
                                typeString: "int24"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 116,
                        initialValue: {
                          arguments: [
                            {
                              id: 113,
                              name: "pool",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 97,
                              src: "3076:4:0",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 114,
                              name: "secondsAgo",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91,
                              src: "3082:10:0",
                              typeDescriptions: {
                                typeIdentifier: "t_uint32",
                                typeString: "uint32"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint32",
                                typeString: "uint32"
                              }
                            ],
                            id: 112,
                            name: "_getArithmeticMeanTick",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 452,
                            src: "3053:22:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_view$_t_address_$_t_uint32_$returns$_t_int24_$",
                              typeString:
                                "function (address,uint32) view returns (int24)"
                            }
                          },
                          id: 115,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3053:40:0",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_int24",
                            typeString: "int24"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "3026:67:0"
                      },
                      {
                        expression: {
                          id: 125,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 117,
                            name: "quoteAmount",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94,
                            src: "3102:11:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 120,
                                name: "arithmeticMeanTick",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 111,
                                src: "3154:18:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_int24",
                                  typeString: "int24"
                                }
                              },
                              {
                                id: 121,
                                name: "baseAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 85,
                                src: "3182:10:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                }
                              },
                              {
                                id: 122,
                                name: "baseToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 87,
                                src: "3202:9:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              {
                                id: 123,
                                name: "quoteToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89,
                                src: "3221:10:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_int24",
                                  typeString: "int24"
                                },
                                {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                },
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                },
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              expression: {
                                id: 118,
                                name: "OracleLibrary",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 20341,
                                src: "3116:13:0",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_type$_t_contract$_OracleLibrary_$20341_$",
                                  typeString: "type(library OracleLibrary)"
                                }
                              },
                              id: 119,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "3130:14:0",
                              memberName: "getQuoteAtTick",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 19968,
                              src: "3116:28:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_int24_$_t_uint128_$_t_address_$_t_address_$returns$_t_uint256_$",
                                typeString:
                                  "function (int24,uint128,address,address) pure returns (uint256)"
                              }
                            },
                            id: 124,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3116:123:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3102:137:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 126,
                        nodeType: "ExpressionStatement",
                        src: "3102:137:0"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [602],
            documentation: {
              id: 83,
              nodeType: "StructuredDocumentation",
              src: "2094:669:0",
              text: "@notice Get the time-weighted quote of `quoteToken` received in exchange for a `baseAmount`\n of `baseToken`, from the pool with highest liquidity, based on a `secondsAgo` twap interval.\n Requirement: secondsAgo must be greater than 0.\n @param baseAmount Amount of token to be converted\n @param baseToken Address of an ERC20 token contract used as the baseAmount denomination\n @param quoteToken Address of an ERC20 token contract used as the quoteAmount denomination\n @param secondsAgo Number of seconds in the past from which to calculate the time-weighted quote\n @return quoteAmount Equivalent amount of ERC20 token for baseAmount"
            },
            functionSelector: "63711362",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getQuote",
            nameLocation: "2775:8:0",
            parameters: {
              id: 92,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 85,
                  mutability: "mutable",
                  name: "baseAmount",
                  nameLocation: "2797:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 130,
                  src: "2789:18:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint128",
                    typeString: "uint128"
                  },
                  typeName: {
                    id: 84,
                    name: "uint128",
                    nodeType: "ElementaryTypeName",
                    src: "2789:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint128",
                      typeString: "uint128"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 87,
                  mutability: "mutable",
                  name: "baseToken",
                  nameLocation: "2821:9:0",
                  nodeType: "VariableDeclaration",
                  scope: 130,
                  src: "2813:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 86,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2813:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 89,
                  mutability: "mutable",
                  name: "quoteToken",
                  nameLocation: "2844:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 130,
                  src: "2836:18:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 88,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2836:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91,
                  mutability: "mutable",
                  name: "secondsAgo",
                  nameLocation: "2867:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 130,
                  src: "2860:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint32",
                    typeString: "uint32"
                  },
                  typeName: {
                    id: 90,
                    name: "uint32",
                    nodeType: "ElementaryTypeName",
                    src: "2860:6:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2783:98:0"
            },
            returnParameters: {
              id: 95,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94,
                  mutability: "mutable",
                  name: "quoteAmount",
                  nameLocation: "2911:11:0",
                  nodeType: "VariableDeclaration",
                  scope: 130,
                  src: "2903:19:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2903:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2902:21:0"
            },
            scope: 558,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 184,
            nodeType: "FunctionDefinition",
            src: "3816:550:0",
            body: {
              id: 183,
              nodeType: "Block",
              src: "3950:416:0",
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 145,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 143,
                      name: "updateInterval",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 137,
                      src: "4013:14:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 144,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "4031:1:0",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "4013:19:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 151,
                  nodeType: "IfStatement",
                  src: "4009:58:0",
                  trueBody: {
                    expression: {
                      arguments: [
                        {
                          id: 147,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 133,
                          src: "4052:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 148,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 135,
                          src: "4060:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 146,
                        name: "updatePool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 354,
                        src: "4041:10:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_nonpayable$_t_address_$_t_address_$returns$_t_struct$_PoolData_$649_memory_ptr_$",
                          typeString:
                            "function (address,address) returns (struct PoolData memory)"
                        }
                      },
                      id: 149,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "4041:26:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    functionReturnParameters: 142,
                    id: 150,
                    nodeType: "Return",
                    src: "4034:33:0"
                  }
                },
                {
                  expression: {
                    id: 157,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 152,
                      name: "pool",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 141,
                      src: "4074:4:0",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 154,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 133,
                          src: "4089:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 155,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 135,
                          src: "4097:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 153,
                        name: "getPool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82,
                        src: "4081:7:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_view$_t_address_$_t_address_$returns$_t_struct$_PoolData_$649_memory_ptr_$",
                          typeString:
                            "function (address,address) view returns (struct PoolData memory)"
                        }
                      },
                      id: 156,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "4081:23:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    src: "4074:30:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                      typeString: "struct PoolData memory"
                    }
                  },
                  id: 158,
                  nodeType: "ExpressionStatement",
                  src: "4074:30:0"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 173,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 165,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 159,
                          name: "pool",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 141,
                          src: "4206:4:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_struct$_PoolData_$649_memory_ptr",
                            typeString: "struct PoolData memory"
                          }
                        },
                        id: 160,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "4211:11:0",
                        memberName: "poolAddress",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 644,
                        src: "4206:16:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        arguments: [
                          {
                            hexValue: "30",
                            id: 163,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "4234:1:0",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            }
                          ],
                          id: 162,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "4226:7:0",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_address_$",
                            typeString: "type(address)"
                          },
                          typeName: {
                            id: 161,
                            name: "address",
                            nodeType: "ElementaryTypeName",
                            src: "4226:7:0",
                            typeDescriptions: {}
                          }
                        },
                        id: 164,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "4226:10:0",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "4206:30:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 172,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 169,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            id: 166,
                            name: "pool",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 141,
                            src: "4246:4:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_struct$_PoolData_$649_memory_ptr",
                              typeString: "struct PoolData memory"
                            }
                          },
                          id: 167,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "4251:20:0",
                          memberName: "lastUpdatedTimestamp",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 648,
                          src: "4246:25:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "+",
                        rightExpression: {
                          id: 168,
                          name: "updateInterval",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 137,
                          src: "4274:14:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "4246:42:0",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<=",
                      rightExpression: {
                        expression: {
                          id: 170,
                          name: "block",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -4,
                          src: "4292:5:0",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_block",
                            typeString: "block"
                          }
                        },
                        id: 171,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "4298:9:0",
                        memberName: "timestamp",
                        nodeType: "MemberAccess",
                        src: "4292:15:0",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "4246:61:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "4206:101:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 182,
                  nodeType: "IfStatement",
                  src: "4195:167:0",
                  trueBody: {
                    id: 181,
                    nodeType: "Block",
                    src: "4314:48:0",
                    statements: [
                      {
                        expression: {
                          id: 179,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 174,
                            name: "pool",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 141,
                            src: "4322:4:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_struct$_PoolData_$649_memory_ptr",
                              typeString: "struct PoolData memory"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 176,
                                name: "tokenA",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 133,
                                src: "4340:6:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              {
                                id: 177,
                                name: "tokenB",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 135,
                                src: "4348:6:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                },
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              id: 175,
                              name: "updatePool",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 354,
                              src: "4329:10:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_nonpayable$_t_address_$_t_address_$returns$_t_struct$_PoolData_$649_memory_ptr_$",
                                typeString:
                                  "function (address,address) returns (struct PoolData memory)"
                              }
                            },
                            id: 178,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "4329:26:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier:
                                "t_struct$_PoolData_$649_memory_ptr",
                              typeString: "struct PoolData memory"
                            }
                          },
                          src: "4322:33:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_struct$_PoolData_$649_memory_ptr",
                            typeString: "struct PoolData memory"
                          }
                        },
                        id: 180,
                        nodeType: "ExpressionStatement",
                        src: "4322:33:0"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [614],
            documentation: {
              id: 131,
              nodeType: "StructuredDocumentation",
              src: "3254:559:0",
              text: "@notice Retrieves pool given tokenA and tokenB, regardless of order, and updates pool if necessary.\n @param tokenA Address of one of the ERC20 token contract in the pool\n @param tokenB Address of the other ERC20 token contract in the pool\n @param updateInterval Seconds after which a pool is considered stale and an update is triggered\n @return pool address, fee and last edit timestamp.\n Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool\n has not been stored yet."
            },
            functionSelector: "6cd62fb3",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getUpdatedPool",
            nameLocation: "3825:14:0",
            parameters: {
              id: 138,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 133,
                  mutability: "mutable",
                  name: "tokenA",
                  nameLocation: "3853:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 184,
                  src: "3845:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 132,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3845:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 135,
                  mutability: "mutable",
                  name: "tokenB",
                  nameLocation: "3873:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 184,
                  src: "3865:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 134,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3865:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 137,
                  mutability: "mutable",
                  name: "updateInterval",
                  nameLocation: "3893:14:0",
                  nodeType: "VariableDeclaration",
                  scope: 184,
                  src: "3885:22:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 136,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3885:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3839:72:0"
            },
            returnParameters: {
              id: 142,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 141,
                  mutability: "mutable",
                  name: "pool",
                  nameLocation: "3944:4:0",
                  nodeType: "VariableDeclaration",
                  scope: 184,
                  src: "3928:20:0",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                    typeString: "struct PoolData"
                  },
                  typeName: {
                    id: 140,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 139,
                      name: "PoolData",
                      nameLocations: ["3928:8:0"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 649,
                      src: "3928:8:0"
                    },
                    referencedDeclaration: 649,
                    src: "3928:8:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_storage_ptr",
                      typeString: "struct PoolData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3927:22:0"
            },
            scope: 558,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 235,
            nodeType: "FunctionDefinition",
            src: "5153:550:0",
            body: {
              id: 234,
              nodeType: "Block",
              src: "5347:356:0",
              statements: [
                {
                  assignments: [201],
                  declarations: [
                    {
                      constant: false,
                      id: 201,
                      mutability: "mutable",
                      name: "pool",
                      nameLocation: "5361:4:0",
                      nodeType: "VariableDeclaration",
                      scope: 234,
                      src: "5353:12:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 200,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "5353:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 208,
                  initialValue: {
                    expression: {
                      arguments: [
                        {
                          id: 203,
                          name: "baseToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 189,
                          src: "5383:9:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 204,
                          name: "quoteToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 191,
                          src: "5394:10:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 205,
                          name: "updateInterval",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 195,
                          src: "5406:14:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 202,
                        name: "getUpdatedPool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 184,
                        src: "5368:14:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_struct$_PoolData_$649_memory_ptr_$",
                          typeString:
                            "function (address,address,uint256) returns (struct PoolData memory)"
                        }
                      },
                      id: 206,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "5368:53:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    id: 207,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "5429:11:0",
                    memberName: "poolAddress",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 644,
                    src: "5368:72:0",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5353:87:0"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 214,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 209,
                      name: "pool",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 201,
                      src: "5451:4:0",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 212,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "5467:1:0",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 211,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "5459:7:0",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 210,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "5459:7:0",
                          typeDescriptions: {}
                        }
                      },
                      id: 213,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "5459:10:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "5451:18:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 233,
                  nodeType: "IfStatement",
                  src: "5447:252:0",
                  trueBody: {
                    id: 232,
                    nodeType: "Block",
                    src: "5471:228:0",
                    statements: [
                      {
                        assignments: [216],
                        declarations: [
                          {
                            constant: false,
                            id: 216,
                            mutability: "mutable",
                            name: "arithmeticMeanTick",
                            nameLocation: "5485:18:0",
                            nodeType: "VariableDeclaration",
                            scope: 232,
                            src: "5479:24:0",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_int24",
                              typeString: "int24"
                            },
                            typeName: {
                              id: 215,
                              name: "int24",
                              nodeType: "ElementaryTypeName",
                              src: "5479:5:0",
                              typeDescriptions: {
                                typeIdentifier: "t_int24",
                                typeString: "int24"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 221,
                        initialValue: {
                          arguments: [
                            {
                              id: 218,
                              name: "pool",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 201,
                              src: "5529:4:0",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 219,
                              name: "secondsAgo",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 193,
                              src: "5535:10:0",
                              typeDescriptions: {
                                typeIdentifier: "t_uint32",
                                typeString: "uint32"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint32",
                                typeString: "uint32"
                              }
                            ],
                            id: 217,
                            name: "_getArithmeticMeanTick",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 452,
                            src: "5506:22:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_view$_t_address_$_t_uint32_$returns$_t_int24_$",
                              typeString:
                                "function (address,uint32) view returns (int24)"
                            }
                          },
                          id: 220,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "5506:40:0",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_int24",
                            typeString: "int24"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "5479:67:0"
                      },
                      {
                        expression: {
                          id: 230,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 222,
                            name: "quoteAmount",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 198,
                            src: "5555:11:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 225,
                                name: "arithmeticMeanTick",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 216,
                                src: "5607:18:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_int24",
                                  typeString: "int24"
                                }
                              },
                              {
                                id: 226,
                                name: "baseAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 187,
                                src: "5635:10:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                }
                              },
                              {
                                id: 227,
                                name: "baseToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 189,
                                src: "5655:9:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              {
                                id: 228,
                                name: "quoteToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 191,
                                src: "5674:10:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_int24",
                                  typeString: "int24"
                                },
                                {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                },
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                },
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              expression: {
                                id: 223,
                                name: "OracleLibrary",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 20341,
                                src: "5569:13:0",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_type$_t_contract$_OracleLibrary_$20341_$",
                                  typeString: "type(library OracleLibrary)"
                                }
                              },
                              id: 224,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "5583:14:0",
                              memberName: "getQuoteAtTick",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 19968,
                              src: "5569:28:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_int24_$_t_uint128_$_t_address_$_t_address_$returns$_t_uint256_$",
                                typeString:
                                  "function (int24,uint128,address,address) pure returns (uint256)"
                              }
                            },
                            id: 229,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "5569:123:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "5555:137:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 231,
                        nodeType: "ExpressionStatement",
                        src: "5555:137:0"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [629],
            documentation: {
              id: 185,
              nodeType: "StructuredDocumentation",
              src: "4370:780:0",
              text: "@notice Get the time-weighted quote of `quoteToken`, and updates the pool in case there is no pool stored.\n @param baseAmount Amount of token to be converted\n @param baseToken Address of an ERC20 token contract used as the baseAmount denomination\n @param quoteToken Address of an ERC20 token contract used as the quoteAmount denomination\n @param secondsAgo Number of seconds in the past from which to calculate the time-weighted quote\n @param updateInterval Seconds after which a pool is considered stale and an update is triggered\n @return quoteAmount Equivalent amount of ERC20 token for baseAmount\n Note: Set updateInterval to 0 to always trigger an update, or to block.timestamp to only update if a pool\n has not been stored yet."
            },
            functionSelector: "cb41861d",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getQuoteAndUpdatePool",
            nameLocation: "5162:21:0",
            parameters: {
              id: 196,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 187,
                  mutability: "mutable",
                  name: "baseAmount",
                  nameLocation: "5197:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5189:18:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint128",
                    typeString: "uint128"
                  },
                  typeName: {
                    id: 186,
                    name: "uint128",
                    nodeType: "ElementaryTypeName",
                    src: "5189:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint128",
                      typeString: "uint128"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 189,
                  mutability: "mutable",
                  name: "baseToken",
                  nameLocation: "5221:9:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5213:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 188,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5213:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 191,
                  mutability: "mutable",
                  name: "quoteToken",
                  nameLocation: "5244:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5236:18:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 190,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5236:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 193,
                  mutability: "mutable",
                  name: "secondsAgo",
                  nameLocation: "5267:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5260:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint32",
                    typeString: "uint32"
                  },
                  typeName: {
                    id: 192,
                    name: "uint32",
                    nodeType: "ElementaryTypeName",
                    src: "5260:6:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 195,
                  mutability: "mutable",
                  name: "updateInterval",
                  nameLocation: "5291:14:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5283:22:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 194,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5283:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5183:126:0"
            },
            returnParameters: {
              id: 199,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 198,
                  mutability: "mutable",
                  name: "quoteAmount",
                  nameLocation: "5334:11:0",
                  nodeType: "VariableDeclaration",
                  scope: 235,
                  src: "5326:19:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 197,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5326:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5325:21:0"
            },
            scope: 558,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 354,
            nodeType: "FunctionDefinition",
            src: "6015:1556:0",
            body: {
              id: 353,
              nodeType: "Block",
              src: "6131:1440:0",
              statements: [
                {
                  assignments: [247, 249],
                  declarations: [
                    {
                      constant: false,
                      id: 247,
                      mutability: "mutable",
                      name: "token0",
                      nameLocation: "6175:6:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6167:14:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 246,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "6167:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 249,
                      mutability: "mutable",
                      name: "token1",
                      nameLocation: "6191:6:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6183:14:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 248,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "6183:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 260,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 252,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 250,
                        name: "tokenA",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 238,
                        src: "6201:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<",
                      rightExpression: {
                        id: 251,
                        name: "tokenB",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 240,
                        src: "6210:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "6201:15:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      components: [
                        {
                          id: 256,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 240,
                          src: "6251:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 257,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 238,
                          src: "6259:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      id: 258,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "TupleExpression",
                      src: "6250:16:0",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                        typeString: "tuple(address,address)"
                      }
                    },
                    id: 259,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "6201:65:0",
                    trueExpression: {
                      components: [
                        {
                          id: 253,
                          name: "tokenA",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 238,
                          src: "6226:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 254,
                          name: "tokenB",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 240,
                          src: "6234:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      id: 255,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "TupleExpression",
                      src: "6225:16:0",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                        typeString: "tuple(address,address)"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_address_$_t_address_$",
                      typeString: "tuple(address,address)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6166:100:0"
                },
                {
                  assignments: [262],
                  declarations: [
                    {
                      constant: false,
                      id: 262,
                      mutability: "mutable",
                      name: "highestLiquidity",
                      nameLocation: "6339:16:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6331:24:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 261,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "6331:7:0",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 263,
                  nodeType: "VariableDeclarationStatement",
                  src: "6331:24:0"
                },
                {
                  assignments: [268],
                  declarations: [
                    {
                      constant: false,
                      id: 268,
                      mutability: "mutable",
                      name: "fees_",
                      nameLocation: "6423:5:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6407:21:0",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint24_$dyn_memory_ptr",
                        typeString: "uint24[]"
                      },
                      typeName: {
                        baseType: {
                          id: 266,
                          name: "uint24",
                          nodeType: "ElementaryTypeName",
                          src: "6407:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint24",
                            typeString: "uint24"
                          }
                        },
                        id: 267,
                        nodeType: "ArrayTypeName",
                        src: "6407:8:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint24_$dyn_storage_ptr",
                          typeString: "uint24[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 270,
                  initialValue: {
                    id: 269,
                    name: "fees",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 26,
                    src: "6431:4:0",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint24_$dyn_storage",
                      typeString: "uint24[] storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6407:28:0"
                },
                {
                  assignments: [272],
                  declarations: [
                    {
                      constant: false,
                      id: 272,
                      mutability: "mutable",
                      name: "poolAddress",
                      nameLocation: "6449:11:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6441:19:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 271,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "6441:7:0",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 273,
                  nodeType: "VariableDeclarationStatement",
                  src: "6441:19:0"
                },
                {
                  assignments: [275],
                  declarations: [
                    {
                      constant: false,
                      id: 275,
                      mutability: "mutable",
                      name: "harmonicMeanLiquidity",
                      nameLocation: "6474:21:0",
                      nodeType: "VariableDeclaration",
                      scope: 353,
                      src: "6466:29:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 274,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "6466:7:0",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 276,
                  nodeType: "VariableDeclarationStatement",
                  src: "6466:29:0"
                },
                {
                  body: {
                    id: 339,
                    nodeType: "Block",
                    src: "6526:783:0",
                    statements: [
                      {
                        expression: {
                          id: 296,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 283,
                            name: "poolAddress",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 272,
                            src: "6564:11:0",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 286,
                                name: "uniswapV3Factory",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 28,
                                src: "6614:16:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              {
                                arguments: [
                                  {
                                    id: 289,
                                    name: "token0",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 247,
                                    src: "6660:6:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    id: 290,
                                    name: "token1",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 249,
                                    src: "6668:6:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    baseExpression: {
                                      id: 291,
                                      name: "fees_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 268,
                                      src: "6676:5:0",
                                      typeDescriptions: {
                                        typeIdentifier:
                                          "t_array$_t_uint24_$dyn_memory_ptr",
                                        typeString: "uint24[] memory"
                                      }
                                    },
                                    id: 293,
                                    indexExpression: {
                                      id: 292,
                                      name: "i",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 278,
                                      src: "6682:1:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "6676:8:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint24",
                                      typeString: "uint24"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_uint24",
                                      typeString: "uint24"
                                    }
                                  ],
                                  expression: {
                                    id: 287,
                                    name: "PoolAddress",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 746,
                                    src: "6640:11:0",
                                    typeDescriptions: {
                                      typeIdentifier:
                                        "t_type$_t_contract$_PoolAddress_$746_$",
                                      typeString: "type(library PoolAddress)"
                                    }
                                  },
                                  id: 288,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "6652:7:0",
                                  memberName: "PoolKey",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 662,
                                  src: "6640:19:0",
                                  typeDescriptions: {
                                    typeIdentifier:
                                      "t_type$_t_struct$_PoolKey_$662_storage_ptr_$",
                                    typeString:
                                      "type(struct PoolAddress.PoolKey storage pointer)"
                                  }
                                },
                                id: 294,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "structConstructorCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "6640:45:0",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_PoolKey_$662_memory_ptr",
                                  typeString:
                                    "struct PoolAddress.PoolKey memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                },
                                {
                                  typeIdentifier:
                                    "t_struct$_PoolKey_$662_memory_ptr",
                                  typeString:
                                    "struct PoolAddress.PoolKey memory"
                                }
                              ],
                              expression: {
                                id: 284,
                                name: "PoolAddress",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 746,
                                src: "6578:11:0",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_type$_t_contract$_PoolAddress_$746_$",
                                  typeString: "type(library PoolAddress)"
                                }
                              },
                              id: 285,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "6590:14:0",
                              memberName: "computeAddress",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 745,
                              src: "6578:26:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_address_$_t_struct$_PoolKey_$662_memory_ptr_$returns$_t_address_$",
                                typeString:
                                  "function (address,struct PoolAddress.PoolKey memory) pure returns (address)"
                              }
                            },
                            id: 295,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6578:115:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6564:129:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        id: 297,
                        nodeType: "ExpressionStatement",
                        src: "6564:129:0"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 302,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              expression: {
                                id: 298,
                                name: "poolAddress",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 272,
                                src: "6741:11:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              id: 299,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "6753:4:0",
                              memberName: "code",
                              nodeType: "MemberAccess",
                              src: "6741:16:0",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            },
                            id: 300,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6758:6:0",
                            memberName: "length",
                            nodeType: "MemberAccess",
                            src: "6741:23:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: ">",
                          rightExpression: {
                            hexValue: "30",
                            id: 301,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "6767:1:0",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "6741:27:0",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 334,
                        nodeType: "IfStatement",
                        src: "6737:526:0",
                        trueBody: {
                          id: 333,
                          nodeType: "Block",
                          src: "6770:493:0",
                          statements: [
                            {
                              expression: {
                                id: 308,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  id: 303,
                                  name: "harmonicMeanLiquidity",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 275,
                                  src: "6826:21:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  arguments: [
                                    {
                                      id: 305,
                                      name: "poolAddress",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 272,
                                      src: "6876:11:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_address",
                                        typeString: "address"
                                      }
                                    },
                                    {
                                      hexValue: "31383030",
                                      id: 306,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: true,
                                      kind: "number",
                                      lValueRequested: false,
                                      nodeType: "Literal",
                                      src: "6889:4:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_rational_1800_by_1",
                                        typeString: "int_const 1800"
                                      },
                                      value: "1800"
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_address",
                                        typeString: "address"
                                      },
                                      {
                                        typeIdentifier: "t_rational_1800_by_1",
                                        typeString: "int_const 1800"
                                      }
                                    ],
                                    id: 304,
                                    name: "_getHarmonicMeanLiquidity",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 557,
                                    src: "6850:25:0",
                                    typeDescriptions: {
                                      typeIdentifier:
                                        "t_function_internal_view$_t_address_$_t_uint32_$returns$_t_uint128_$",
                                      typeString:
                                        "function (address,uint32) view returns (uint128)"
                                    }
                                  },
                                  id: 307,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "functionCall",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "6850:44:0",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint128",
                                    typeString: "uint128"
                                  }
                                },
                                src: "6826:68:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 309,
                              nodeType: "ExpressionStatement",
                              src: "6826:68:0"
                            },
                            {
                              condition: {
                                commonType: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                id: 312,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  id: 310,
                                  name: "harmonicMeanLiquidity",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 275,
                                  src: "6974:21:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: ">",
                                rightExpression: {
                                  id: 311,
                                  name: "highestLiquidity",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 262,
                                  src: "6998:16:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                src: "6974:40:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_bool",
                                  typeString: "bool"
                                }
                              },
                              id: 332,
                              nodeType: "IfStatement",
                              src: "6970:285:0",
                              trueBody: {
                                id: 331,
                                nodeType: "Block",
                                src: "7016:239:0",
                                statements: [
                                  {
                                    expression: {
                                      id: 315,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftHandSide: {
                                        id: 313,
                                        name: "highestLiquidity",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 262,
                                        src: "7065:16:0",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      nodeType: "Assignment",
                                      operator: "=",
                                      rightHandSide: {
                                        id: 314,
                                        name: "harmonicMeanLiquidity",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 275,
                                        src: "7084:21:0",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      src: "7065:40:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    id: 316,
                                    nodeType: "ExpressionStatement",
                                    src: "7065:40:0"
                                  },
                                  {
                                    expression: {
                                      id: 329,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftHandSide: {
                                        id: 317,
                                        name: "highestLiquidityPool",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 244,
                                        src: "7117:20:0",
                                        typeDescriptions: {
                                          typeIdentifier:
                                            "t_struct$_PoolData_$649_memory_ptr",
                                          typeString: "struct PoolData memory"
                                        }
                                      },
                                      nodeType: "Assignment",
                                      operator: "=",
                                      rightHandSide: {
                                        arguments: [
                                          {
                                            id: 319,
                                            name: "poolAddress",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 272,
                                            src: "7162:11:0",
                                            typeDescriptions: {
                                              typeIdentifier: "t_address",
                                              typeString: "address"
                                            }
                                          },
                                          {
                                            baseExpression: {
                                              id: 320,
                                              name: "fees_",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 268,
                                              src: "7187:5:0",
                                              typeDescriptions: {
                                                typeIdentifier:
                                                  "t_array$_t_uint24_$dyn_memory_ptr",
                                                typeString: "uint24[] memory"
                                              }
                                            },
                                            id: 322,
                                            indexExpression: {
                                              id: 321,
                                              name: "i",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 278,
                                              src: "7193:1:0",
                                              typeDescriptions: {
                                                typeIdentifier: "t_uint256",
                                                typeString: "uint256"
                                              }
                                            },
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: false,
                                            nodeType: "IndexAccess",
                                            src: "7187:8:0",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint24",
                                              typeString: "uint24"
                                            }
                                          },
                                          {
                                            arguments: [
                                              {
                                                expression: {
                                                  id: 325,
                                                  name: "block",
                                                  nodeType: "Identifier",
                                                  overloadedDeclarations: [],
                                                  referencedDeclaration: -4,
                                                  src: "7216:5:0",
                                                  typeDescriptions: {
                                                    typeIdentifier:
                                                      "t_magic_block",
                                                    typeString: "block"
                                                  }
                                                },
                                                id: 326,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberLocation: "7222:9:0",
                                                memberName: "timestamp",
                                                nodeType: "MemberAccess",
                                                src: "7216:15:0",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              }
                                            ],
                                            expression: {
                                              argumentTypes: [
                                                {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              ],
                                              id: 324,
                                              isConstant: false,
                                              isLValue: false,
                                              isPure: true,
                                              lValueRequested: false,
                                              nodeType:
                                                "ElementaryTypeNameExpression",
                                              src: "7209:6:0",
                                              typeDescriptions: {
                                                typeIdentifier:
                                                  "t_type$_t_uint48_$",
                                                typeString: "type(uint48)"
                                              },
                                              typeName: {
                                                id: 323,
                                                name: "uint48",
                                                nodeType: "ElementaryTypeName",
                                                src: "7209:6:0",
                                                typeDescriptions: {}
                                              }
                                            },
                                            id: 327,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: "typeConversion",
                                            lValueRequested: false,
                                            nameLocations: [],
                                            names: [],
                                            nodeType: "FunctionCall",
                                            src: "7209:23:0",
                                            tryCall: false,
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint48",
                                              typeString: "uint48"
                                            }
                                          }
                                        ],
                                        expression: {
                                          argumentTypes: [
                                            {
                                              typeIdentifier: "t_address",
                                              typeString: "address"
                                            },
                                            {
                                              typeIdentifier: "t_uint24",
                                              typeString: "uint24"
                                            },
                                            {
                                              typeIdentifier: "t_uint48",
                                              typeString: "uint48"
                                            }
                                          ],
                                          id: 318,
                                          name: "PoolData",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 649,
                                          src: "7140:8:0",
                                          typeDescriptions: {
                                            typeIdentifier:
                                              "t_type$_t_struct$_PoolData_$649_storage_ptr_$",
                                            typeString:
                                              "type(struct PoolData storage pointer)"
                                          }
                                        },
                                        id: 328,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: "structConstructorCall",
                                        lValueRequested: false,
                                        nameLocations: [],
                                        names: [],
                                        nodeType: "FunctionCall",
                                        src: "7140:104:0",
                                        tryCall: false,
                                        typeDescriptions: {
                                          typeIdentifier:
                                            "t_struct$_PoolData_$649_memory_ptr",
                                          typeString: "struct PoolData memory"
                                        }
                                      },
                                      src: "7117:127:0",
                                      typeDescriptions: {
                                        typeIdentifier:
                                          "t_struct$_PoolData_$649_memory_ptr",
                                        typeString: "struct PoolData memory"
                                      }
                                    },
                                    id: 330,
                                    nodeType: "ExpressionStatement",
                                    src: "7117:127:0"
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        id: 338,
                        nodeType: "UncheckedBlock",
                        src: "7271:32:0",
                        statements: [
                          {
                            expression: {
                              id: 336,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "UnaryOperation",
                              operator: "++",
                              prefix: true,
                              src: "7291:3:0",
                              subExpression: {
                                id: 335,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 278,
                                src: "7293:1:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 337,
                            nodeType: "ExpressionStatement",
                            src: "7291:3:0"
                          }
                        ]
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 282,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 280,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 278,
                      src: "6517:1:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      hexValue: "34",
                      id: 281,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "6521:1:0",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_4_by_1",
                        typeString: "int_const 4"
                      },
                      value: "4"
                    },
                    src: "6517:5:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 340,
                  initializationExpression: {
                    assignments: [278],
                    declarations: [
                      {
                        constant: false,
                        id: 278,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "6514:1:0",
                        nodeType: "VariableDeclaration",
                        scope: 340,
                        src: "6506:9:0",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        typeName: {
                          id: 277,
                          name: "uint256",
                          nodeType: "ElementaryTypeName",
                          src: "6506:7:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 279,
                    nodeType: "VariableDeclarationStatement",
                    src: "6506:9:0"
                  },
                  nodeType: "ForStatement",
                  src: "6501:808:0"
                },
                {
                  documentation:
                    "Update stored pool with `highestLiquidityPool`\n @dev New value should be stored even if highestPool = currentPool to update `lastUpdatedTimestamp`.",
                  expression: {
                    id: 347,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        baseExpression: {
                          id: 341,
                          name: "pools",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 36,
                          src: "7478:5:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_mapping$_t_address_$_t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$_$",
                            typeString:
                              "mapping(address => mapping(address => struct PoolData storage ref))"
                          }
                        },
                        id: 344,
                        indexExpression: {
                          id: 342,
                          name: "token0",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 247,
                          src: "7484:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "7478:13:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_address_$_t_struct$_PoolData_$649_storage_$",
                          typeString:
                            "mapping(address => struct PoolData storage ref)"
                        }
                      },
                      id: 345,
                      indexExpression: {
                        id: 343,
                        name: "token1",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 249,
                        src: "7492:6:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "7478:21:0",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_storage",
                        typeString: "struct PoolData storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 346,
                      name: "highestLiquidityPool",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 244,
                      src: "7502:20:0",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                        typeString: "struct PoolData memory"
                      }
                    },
                    src: "7478:44:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_storage",
                      typeString: "struct PoolData storage ref"
                    }
                  },
                  id: 348,
                  nodeType: "ExpressionStatement",
                  src: "7478:44:0"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 350,
                        name: "highestLiquidityPool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 244,
                        src: "7545:20:0",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                          typeString: "struct PoolData memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                          typeString: "struct PoolData memory"
                        }
                      ],
                      id: 349,
                      name: "PoolUpdated",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 17,
                      src: "7533:11:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_struct$_PoolData_$649_memory_ptr_$returns$__$",
                        typeString: "function (struct PoolData memory)"
                      }
                    },
                    id: 351,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "7533:33:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 352,
                  nodeType: "EmitStatement",
                  src: "7528:38:0"
                }
              ]
            },
            baseFunctions: [639],
            documentation: {
              id: 236,
              nodeType: "StructuredDocumentation",
              src: "5707:305:0",
              text: "@notice Updates stored pool with the one having the highest liquidity.\n @param tokenA Address of one of the ERC20 token contract in the pool\n @param tokenB Address of the other ERC20 token contract in the pool\n @return highestLiquidityPool Pool with the highest harmonicMeanLiquidity"
            },
            functionSelector: "80e1ed82",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "updatePool",
            nameLocation: "6024:10:0",
            parameters: {
              id: 241,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 238,
                  mutability: "mutable",
                  name: "tokenA",
                  nameLocation: "6043:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 354,
                  src: "6035:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 237,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6035:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 240,
                  mutability: "mutable",
                  name: "tokenB",
                  nameLocation: "6059:6:0",
                  nodeType: "VariableDeclaration",
                  scope: 354,
                  src: "6051:14:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 239,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6051:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "6034:32:0"
            },
            returnParameters: {
              id: 245,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 244,
                  mutability: "mutable",
                  name: "highestLiquidityPool",
                  nameLocation: "6107:20:0",
                  nodeType: "VariableDeclaration",
                  scope: 354,
                  src: "6091:36:0",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PoolData_$649_memory_ptr",
                    typeString: "struct PoolData"
                  },
                  typeName: {
                    id: 243,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 242,
                      name: "PoolData",
                      nameLocations: ["6091:8:0"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 649,
                      src: "6091:8:0"
                    },
                    referencedDeclaration: 649,
                    src: "6091:8:0",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PoolData_$649_storage_ptr",
                      typeString: "struct PoolData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "6090:38:0"
            },
            scope: 558,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 452,
            nodeType: "FunctionDefinition",
            src: "7961:718:0",
            body: {
              id: 451,
              nodeType: "Block",
              src: "8088:591:0",
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint32",
                          typeString: "uint32"
                        },
                        id: 367,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 365,
                          name: "secondsAgo",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 359,
                          src: "8102:10:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint32",
                            typeString: "uint32"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "!=",
                        rightExpression: {
                          hexValue: "30",
                          id: 366,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "8116:1:0",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        },
                        src: "8102:15:0",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        hexValue: "4250",
                        id: 368,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8119:4:0",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_6f8c752f16a50d13ae873620fdefd90c2c58e0d13a068366e5a1b685076b71bb",
                          typeString: 'literal_string "BP"'
                        },
                        value: "BP"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_6f8c752f16a50d13ae873620fdefd90c2c58e0d13a068366e5a1b685076b71bb",
                          typeString: 'literal_string "BP"'
                        }
                      ],
                      id: 364,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: "8094:7:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 369,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "8094:30:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 370,
                  nodeType: "ExpressionStatement",
                  src: "8094:30:0"
                },
                {
                  assignments: [375],
                  declarations: [
                    {
                      constant: false,
                      id: 375,
                      mutability: "mutable",
                      name: "secondsAgos",
                      nameLocation: "8147:11:0",
                      nodeType: "VariableDeclaration",
                      scope: 451,
                      src: "8131:27:0",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                        typeString: "uint32[]"
                      },
                      typeName: {
                        baseType: {
                          id: 373,
                          name: "uint32",
                          nodeType: "ElementaryTypeName",
                          src: "8131:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint32",
                            typeString: "uint32"
                          }
                        },
                        id: 374,
                        nodeType: "ArrayTypeName",
                        src: "8131:8:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_storage_ptr",
                          typeString: "uint32[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 381,
                  initialValue: {
                    arguments: [
                      {
                        hexValue: "32",
                        id: 379,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8174:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_2_by_1",
                          typeString: "int_const 2"
                        },
                        value: "2"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_rational_2_by_1",
                          typeString: "int_const 2"
                        }
                      ],
                      id: 378,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "NewExpression",
                      src: "8161:12:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_uint32_$dyn_memory_ptr_$",
                        typeString:
                          "function (uint256) pure returns (uint32[] memory)"
                      },
                      typeName: {
                        baseType: {
                          id: 376,
                          name: "uint32",
                          nodeType: "ElementaryTypeName",
                          src: "8165:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint32",
                            typeString: "uint32"
                          }
                        },
                        id: 377,
                        nodeType: "ArrayTypeName",
                        src: "8165:8:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_storage_ptr",
                          typeString: "uint32[]"
                        }
                      }
                    },
                    id: 380,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "8161:15:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                      typeString: "uint32[] memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "8131:45:0"
                },
                {
                  expression: {
                    id: 386,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 382,
                        name: "secondsAgos",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 375,
                        src: "8182:11:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      },
                      id: 384,
                      indexExpression: {
                        hexValue: "30",
                        id: 383,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8194:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "8182:14:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 385,
                      name: "secondsAgo",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 359,
                      src: "8199:10:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    src: "8182:27:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  id: 387,
                  nodeType: "ExpressionStatement",
                  src: "8182:27:0"
                },
                {
                  expression: {
                    id: 392,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 388,
                        name: "secondsAgos",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 375,
                        src: "8215:11:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      },
                      id: 390,
                      indexExpression: {
                        hexValue: "31",
                        id: 389,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8227:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "8215:14:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "30",
                      id: 391,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "8232:1:0",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "8215:18:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  id: 393,
                  nodeType: "ExpressionStatement",
                  src: "8215:18:0"
                },
                {
                  assignments: [398, null],
                  declarations: [
                    {
                      constant: false,
                      id: 398,
                      mutability: "mutable",
                      name: "tickCumulatives",
                      nameLocation: "8256:15:0",
                      nodeType: "VariableDeclaration",
                      scope: 451,
                      src: "8241:30:0",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_int56_$dyn_memory_ptr",
                        typeString: "int56[]"
                      },
                      typeName: {
                        baseType: {
                          id: 396,
                          name: "int56",
                          nodeType: "ElementaryTypeName",
                          src: "8241:5:0",
                          typeDescriptions: {
                            typeIdentifier: "t_int56",
                            typeString: "int56"
                          }
                        },
                        id: 397,
                        nodeType: "ArrayTypeName",
                        src: "8241:7:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_int56_$dyn_storage_ptr",
                          typeString: "int56[]"
                        }
                      },
                      visibility: "internal"
                    },
                    null
                  ],
                  id: 405,
                  initialValue: {
                    arguments: [
                      {
                        id: 403,
                        name: "secondsAgos",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 375,
                        src: "8313:11:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      ],
                      expression: {
                        arguments: [
                          {
                            id: 400,
                            name: "pool",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 357,
                            src: "8292:4:0",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 399,
                          name: "IUniswapV3Pool",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 18552,
                          src: "8277:14:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_type$_t_contract$_IUniswapV3Pool_$18552_$",
                            typeString: "type(contract IUniswapV3Pool)"
                          }
                        },
                        id: 401,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "8277:20:0",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_IUniswapV3Pool_$18552",
                          typeString: "contract IUniswapV3Pool"
                        }
                      },
                      id: 402,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "8298:7:0",
                      memberName: "observe",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 18664,
                      src: "8277:28:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_view$_t_array$_t_uint32_$dyn_memory_ptr_$returns$_t_array$_t_int56_$dyn_memory_ptr_$_t_array$_t_uint160_$dyn_memory_ptr_$",
                        typeString:
                          "function (uint32[] memory) view external returns (int56[] memory,uint160[] memory)"
                      }
                    },
                    id: 404,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "8277:53:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_array$_t_int56_$dyn_memory_ptr_$_t_array$_t_uint160_$dyn_memory_ptr_$",
                      typeString: "tuple(int56[] memory,uint160[] memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "8240:90:0"
                },
                {
                  assignments: [407],
                  declarations: [
                    {
                      constant: false,
                      id: 407,
                      mutability: "mutable",
                      name: "tickCumulativesDelta",
                      nameLocation: "8343:20:0",
                      nodeType: "VariableDeclaration",
                      scope: 451,
                      src: "8337:26:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_int56",
                        typeString: "int56"
                      },
                      typeName: {
                        id: 406,
                        name: "int56",
                        nodeType: "ElementaryTypeName",
                        src: "8337:5:0",
                        typeDescriptions: {
                          typeIdentifier: "t_int56",
                          typeString: "int56"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 415,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_int56",
                      typeString: "int56"
                    },
                    id: 414,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      baseExpression: {
                        id: 408,
                        name: "tickCumulatives",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 398,
                        src: "8366:15:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_int56_$dyn_memory_ptr",
                          typeString: "int56[] memory"
                        }
                      },
                      id: 410,
                      indexExpression: {
                        hexValue: "31",
                        id: 409,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8382:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "8366:18:0",
                      typeDescriptions: {
                        typeIdentifier: "t_int56",
                        typeString: "int56"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      baseExpression: {
                        id: 411,
                        name: "tickCumulatives",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 398,
                        src: "8387:15:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_int56_$dyn_memory_ptr",
                          typeString: "int56[] memory"
                        }
                      },
                      id: 413,
                      indexExpression: {
                        hexValue: "30",
                        id: 412,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8403:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "8387:18:0",
                      typeDescriptions: {
                        typeIdentifier: "t_int56",
                        typeString: "int56"
                      }
                    },
                    src: "8366:39:0",
                    typeDescriptions: {
                      typeIdentifier: "t_int56",
                      typeString: "int56"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "8337:68:0"
                },
                {
                  expression: {
                    id: 429,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 416,
                      name: "arithmeticMeanTick",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 362,
                      src: "8412:18:0",
                      typeDescriptions: {
                        typeIdentifier: "t_int24",
                        typeString: "int24"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          commonType: {
                            typeIdentifier: "t_int56",
                            typeString: "int56"
                          },
                          id: 427,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            id: 419,
                            name: "tickCumulativesDelta",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 407,
                            src: "8446:20:0",
                            typeDescriptions: {
                              typeIdentifier: "t_int56",
                              typeString: "int56"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "/",
                          rightExpression: {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    id: 424,
                                    name: "secondsAgo",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 359,
                                    src: "8482:10:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint32",
                                      typeString: "uint32"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint32",
                                      typeString: "uint32"
                                    }
                                  ],
                                  id: 423,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "8475:6:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_uint56_$",
                                    typeString: "type(uint56)"
                                  },
                                  typeName: {
                                    id: 422,
                                    name: "uint56",
                                    nodeType: "ElementaryTypeName",
                                    src: "8475:6:0",
                                    typeDescriptions: {}
                                  }
                                },
                                id: 425,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "typeConversion",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "8475:18:0",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_uint56",
                                  typeString: "uint56"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint56",
                                  typeString: "uint56"
                                }
                              ],
                              id: 421,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "8469:5:0",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_int56_$",
                                typeString: "type(int56)"
                              },
                              typeName: {
                                id: 420,
                                name: "int56",
                                nodeType: "ElementaryTypeName",
                                src: "8469:5:0",
                                typeDescriptions: {}
                              }
                            },
                            id: 426,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "8469:25:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_int56",
                              typeString: "int56"
                            }
                          },
                          src: "8446:48:0",
                          typeDescriptions: {
                            typeIdentifier: "t_int56",
                            typeString: "int56"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_int56",
                            typeString: "int56"
                          }
                        ],
                        id: 418,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "8433:5:0",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_int24_$",
                          typeString: "type(int24)"
                        },
                        typeName: {
                          id: 417,
                          name: "int24",
                          nodeType: "ElementaryTypeName",
                          src: "8433:5:0",
                          typeDescriptions: {}
                        }
                      },
                      id: 428,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "8433:67:0",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_int24",
                        typeString: "int24"
                      }
                    },
                    src: "8412:88:0",
                    typeDescriptions: {
                      typeIdentifier: "t_int24",
                      typeString: "int24"
                    }
                  },
                  id: 430,
                  nodeType: "ExpressionStatement",
                  src: "8412:88:0"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 446,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_int56",
                        typeString: "int56"
                      },
                      id: 433,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 431,
                        name: "tickCumulativesDelta",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 407,
                        src: "8558:20:0",
                        typeDescriptions: {
                          typeIdentifier: "t_int56",
                          typeString: "int56"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<",
                      rightExpression: {
                        hexValue: "30",
                        id: 432,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "8581:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "8558:24:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "&&",
                    rightExpression: {
                      components: [
                        {
                          commonType: {
                            typeIdentifier: "t_int56",
                            typeString: "int56"
                          },
                          id: 444,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            commonType: {
                              typeIdentifier: "t_int56",
                              typeString: "int56"
                            },
                            id: 442,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 434,
                              name: "tickCumulativesDelta",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 407,
                              src: "8593:20:0",
                              typeDescriptions: {
                                typeIdentifier: "t_int56",
                                typeString: "int56"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "%",
                            rightExpression: {
                              arguments: [
                                {
                                  arguments: [
                                    {
                                      id: 439,
                                      name: "secondsAgo",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 359,
                                      src: "8629:10:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint32",
                                        typeString: "uint32"
                                      }
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_uint32",
                                        typeString: "uint32"
                                      }
                                    ],
                                    id: 438,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "8622:6:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_uint56_$",
                                      typeString: "type(uint56)"
                                    },
                                    typeName: {
                                      id: 437,
                                      name: "uint56",
                                      nodeType: "ElementaryTypeName",
                                      src: "8622:6:0",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 440,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "typeConversion",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "8622:18:0",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint56",
                                    typeString: "uint56"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint56",
                                    typeString: "uint56"
                                  }
                                ],
                                id: 436,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "8616:5:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_int56_$",
                                  typeString: "type(int56)"
                                },
                                typeName: {
                                  id: 435,
                                  name: "int56",
                                  nodeType: "ElementaryTypeName",
                                  src: "8616:5:0",
                                  typeDescriptions: {}
                                }
                              },
                              id: 441,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "8616:25:0",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_int56",
                                typeString: "int56"
                              }
                            },
                            src: "8593:48:0",
                            typeDescriptions: {
                              typeIdentifier: "t_int56",
                              typeString: "int56"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "!=",
                          rightExpression: {
                            hexValue: "30",
                            id: 443,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "8645:1:0",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "8593:53:0",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        }
                      ],
                      id: 445,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "TupleExpression",
                      src: "8592:55:0",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "8558:89:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 450,
                  nodeType: "IfStatement",
                  src: "8547:127:0",
                  trueBody: {
                    expression: {
                      id: 448,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "--",
                      prefix: false,
                      src: "8654:20:0",
                      subExpression: {
                        id: 447,
                        name: "arithmeticMeanTick",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 362,
                        src: "8654:18:0",
                        typeDescriptions: {
                          typeIdentifier: "t_int24",
                          typeString: "int24"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_int24",
                        typeString: "int24"
                      }
                    },
                    id: 449,
                    nodeType: "ExpressionStatement",
                    src: "8654:20:0"
                  }
                }
              ]
            },
            documentation: {
              id: 355,
              nodeType: "StructuredDocumentation",
              src: "7575:383:0",
              text: "@notice Same as `consult` in {OracleLibrary} but saves gas by not calculating `harmonicMeanLiquidity`.\n @param pool Address of the pool that we want to observe\n @param secondsAgo Number of seconds in the past from which to calculate the time-weighted means\n @return arithmeticMeanTick The arithmetic mean tick from (block.timestamp - secondsAgo) to block.timestamp"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getArithmeticMeanTick",
            nameLocation: "7970:22:0",
            parameters: {
              id: 360,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 357,
                  mutability: "mutable",
                  name: "pool",
                  nameLocation: "8001:4:0",
                  nodeType: "VariableDeclaration",
                  scope: 452,
                  src: "7993:12:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 356,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "7993:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 359,
                  mutability: "mutable",
                  name: "secondsAgo",
                  nameLocation: "8014:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 452,
                  src: "8007:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint32",
                    typeString: "uint32"
                  },
                  typeName: {
                    id: 358,
                    name: "uint32",
                    nodeType: "ElementaryTypeName",
                    src: "8007:6:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "7992:33:0"
            },
            returnParameters: {
              id: 363,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 362,
                  mutability: "mutable",
                  name: "arithmeticMeanTick",
                  nameLocation: "8066:18:0",
                  nodeType: "VariableDeclaration",
                  scope: 452,
                  src: "8060:24:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_int24",
                    typeString: "int24"
                  },
                  typeName: {
                    id: 361,
                    name: "int24",
                    nodeType: "ElementaryTypeName",
                    src: "8060:5:0",
                    typeDescriptions: {
                      typeIdentifier: "t_int24",
                      typeString: "int24"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "8059:26:0"
            },
            scope: 558,
            stateMutability: "view",
            virtual: false,
            visibility: "private"
          },
          {
            id: 557,
            nodeType: "FunctionDefinition",
            src: "9171:1127:0",
            body: {
              id: 556,
              nodeType: "Block",
              src: "9306:992:0",
              statements: [
                {
                  assignments: [466],
                  declarations: [
                    {
                      constant: false,
                      id: 466,
                      mutability: "mutable",
                      name: "secondsAgos",
                      nameLocation: "9328:11:0",
                      nodeType: "VariableDeclaration",
                      scope: 556,
                      src: "9312:27:0",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                        typeString: "uint32[]"
                      },
                      typeName: {
                        baseType: {
                          id: 464,
                          name: "uint32",
                          nodeType: "ElementaryTypeName",
                          src: "9312:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint32",
                            typeString: "uint32"
                          }
                        },
                        id: 465,
                        nodeType: "ArrayTypeName",
                        src: "9312:8:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_storage_ptr",
                          typeString: "uint32[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 472,
                  initialValue: {
                    arguments: [
                      {
                        hexValue: "32",
                        id: 470,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "9355:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_2_by_1",
                          typeString: "int_const 2"
                        },
                        value: "2"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_rational_2_by_1",
                          typeString: "int_const 2"
                        }
                      ],
                      id: 469,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "NewExpression",
                      src: "9342:12:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_uint32_$dyn_memory_ptr_$",
                        typeString:
                          "function (uint256) pure returns (uint32[] memory)"
                      },
                      typeName: {
                        baseType: {
                          id: 467,
                          name: "uint32",
                          nodeType: "ElementaryTypeName",
                          src: "9346:6:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint32",
                            typeString: "uint32"
                          }
                        },
                        id: 468,
                        nodeType: "ArrayTypeName",
                        src: "9346:8:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_storage_ptr",
                          typeString: "uint32[]"
                        }
                      }
                    },
                    id: 471,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9342:15:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                      typeString: "uint32[] memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9312:45:0"
                },
                {
                  expression: {
                    id: 477,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 473,
                        name: "secondsAgos",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 466,
                        src: "9363:11:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      },
                      id: 475,
                      indexExpression: {
                        hexValue: "30",
                        id: 474,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "9375:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "9363:14:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 476,
                      name: "secondsAgo",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 457,
                      src: "9380:10:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    src: "9363:27:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  id: 478,
                  nodeType: "ExpressionStatement",
                  src: "9363:27:0"
                },
                {
                  expression: {
                    id: 483,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 479,
                        name: "secondsAgos",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 466,
                        src: "9396:11:0",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint32_$dyn_memory_ptr",
                          typeString: "uint32[] memory"
                        }
                      },
                      id: 481,
                      indexExpression: {
                        hexValue: "31",
                        id: 480,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "9408:1:0",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "9396:14:0",
                      typeDescriptions: {
                        typeIdentifier: "t_uint32",
                        typeString: "uint32"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "30",
                      id: 482,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "9413:1:0",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "9396:18:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  id: 484,
                  nodeType: "ExpressionStatement",
                  src: "9396:18:0"
                },
                {
                  assignments: [486, 488],
                  declarations: [
                    {
                      constant: false,
                      id: 486,
                      mutability: "mutable",
                      name: "success",
                      nameLocation: "9461:7:0",
                      nodeType: "VariableDeclaration",
                      scope: 556,
                      src: "9456:12:0",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      typeName: {
                        id: 485,
                        name: "bool",
                        nodeType: "ElementaryTypeName",
                        src: "9456:4:0",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 488,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "9483:4:0",
                      nodeType: "VariableDeclaration",
                      scope: 556,
                      src: "9470:17:0",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_bytes_memory_ptr",
                        typeString: "bytes"
                      },
                      typeName: {
                        id: 487,
                        name: "bytes",
                        nodeType: "ElementaryTypeName",
                        src: "9470:5:0",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage_ptr",
                          typeString: "bytes"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 497,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            hexValue: "30783838336264626664",
                            id: 493,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "9537:10:0",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_2285624317_by_1",
                              typeString: "int_const 2285624317"
                            },
                            value: "0x883bdbfd"
                          },
                          {
                            id: 494,
                            name: "secondsAgos",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 466,
                            src: "9549:11:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_array$_t_uint32_$dyn_memory_ptr",
                              typeString: "uint32[] memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_2285624317_by_1",
                              typeString: "int_const 2285624317"
                            },
                            {
                              typeIdentifier:
                                "t_array$_t_uint32_$dyn_memory_ptr",
                              typeString: "uint32[] memory"
                            }
                          ],
                          expression: {
                            id: 491,
                            name: "abi",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -1,
                            src: "9514:3:0",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_abi",
                              typeString: "abi"
                            }
                          },
                          id: 492,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          memberLocation: "9518:18:0",
                          memberName: "encodeWithSelector",
                          nodeType: "MemberAccess",
                          src: "9514:22:0",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_abiencodewithselector_pure$_t_bytes4_$returns$_t_bytes_memory_ptr_$",
                            typeString:
                              "function (bytes4) pure returns (bytes memory)"
                          }
                        },
                        id: 495,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "9514:47:0",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      ],
                      expression: {
                        id: 489,
                        name: "pool",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 455,
                        src: "9491:4:0",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      id: 490,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "9496:10:0",
                      memberName: "staticcall",
                      nodeType: "MemberAccess",
                      src: "9491:15:0",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_barestaticcall_view$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$",
                        typeString:
                          "function (bytes memory) view returns (bool,bytes memory)"
                      }
                    },
                    id: 496,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9491:76:0",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_bool_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(bool,bytes memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9455:112:0"
                },
                {
                  condition: {
                    id: 498,
                    name: "success",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 486,
                    src: "9612:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 555,
                  nodeType: "IfStatement",
                  src: "9608:686:0",
                  trueBody: {
                    id: 554,
                    nodeType: "Block",
                    src: "9621:673:0",
                    statements: [
                      {
                        assignments: [null, 503],
                        declarations: [
                          null,
                          {
                            constant: false,
                            id: 503,
                            mutability: "mutable",
                            name: "secondsPerLiquidityCumulativeX128s",
                            nameLocation: "9721:34:0",
                            nodeType: "VariableDeclaration",
                            scope: 554,
                            src: "9704:51:0",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_array$_t_uint160_$dyn_memory_ptr",
                              typeString: "uint160[]"
                            },
                            typeName: {
                              baseType: {
                                id: 501,
                                name: "uint160",
                                nodeType: "ElementaryTypeName",
                                src: "9704:7:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint160",
                                  typeString: "uint160"
                                }
                              },
                              id: 502,
                              nodeType: "ArrayTypeName",
                              src: "9704:9:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_array$_t_uint160_$dyn_storage_ptr",
                                typeString: "uint160[]"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 515,
                        initialValue: {
                          arguments: [
                            {
                              id: 506,
                              name: "data",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 488,
                              src: "9779:4:0",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            },
                            {
                              components: [
                                {
                                  baseExpression: {
                                    id: 508,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "9794:5:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_int56_$",
                                      typeString: "type(int56)"
                                    },
                                    typeName: {
                                      id: 507,
                                      name: "int56",
                                      nodeType: "ElementaryTypeName",
                                      src: "9794:5:0",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 509,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "IndexAccess",
                                  src: "9794:7:0",
                                  typeDescriptions: {
                                    typeIdentifier:
                                      "t_type$_t_array$_t_int56_$dyn_memory_ptr_$",
                                    typeString: "type(int56[] memory)"
                                  }
                                },
                                {
                                  baseExpression: {
                                    id: 511,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "9803:7:0",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_uint160_$",
                                      typeString: "type(uint160)"
                                    },
                                    typeName: {
                                      id: 510,
                                      name: "uint160",
                                      nodeType: "ElementaryTypeName",
                                      src: "9803:7:0",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 512,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "IndexAccess",
                                  src: "9803:9:0",
                                  typeDescriptions: {
                                    typeIdentifier:
                                      "t_type$_t_array$_t_uint160_$dyn_memory_ptr_$",
                                    typeString: "type(uint160[] memory)"
                                  }
                                }
                              ],
                              id: 513,
                              isConstant: false,
                              isInlineArray: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "TupleExpression",
                              src: "9793:20:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_tuple$_t_type$_t_array$_t_int56_$dyn_memory_ptr_$_$_t_type$_t_array$_t_uint160_$dyn_memory_ptr_$_$",
                                typeString:
                                  "tuple(type(int56[] memory),type(uint160[] memory))"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              },
                              {
                                typeIdentifier:
                                  "t_tuple$_t_type$_t_array$_t_int56_$dyn_memory_ptr_$_$_t_type$_t_array$_t_uint160_$dyn_memory_ptr_$_$",
                                typeString:
                                  "tuple(type(int56[] memory),type(uint160[] memory))"
                              }
                            ],
                            expression: {
                              id: 504,
                              name: "abi",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -1,
                              src: "9759:3:0",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_abi",
                                typeString: "abi"
                              }
                            },
                            id: 505,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "9763:6:0",
                            memberName: "decode",
                            nodeType: "MemberAccess",
                            src: "9759:10:0",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_abidecode_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 514,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "9759:62:0",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier:
                              "t_tuple$_t_array$_t_int56_$dyn_memory_ptr_$_t_array$_t_uint160_$dyn_memory_ptr_$",
                            typeString: "tuple(int56[] memory,uint160[] memory)"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "9701:120:0"
                      },
                      {
                        assignments: [517],
                        declarations: [
                          {
                            constant: false,
                            id: 517,
                            mutability: "mutable",
                            name: "secondsPerLiquidityCumulativesDelta",
                            nameLocation: "9838:35:0",
                            nodeType: "VariableDeclaration",
                            scope: 554,
                            src: "9830:43:0",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint160",
                              typeString: "uint160"
                            },
                            typeName: {
                              id: 516,
                              name: "uint160",
                              nodeType: "ElementaryTypeName",
                              src: "9830:7:0",
                              typeDescriptions: {
                                typeIdentifier: "t_uint160",
                                typeString: "uint160"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 525,
                        initialValue: {
                          commonType: {
                            typeIdentifier: "t_uint160",
                            typeString: "uint160"
                          },
                          id: 524,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            baseExpression: {
                              id: 518,
                              name: "secondsPerLiquidityCumulativeX128s",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 503,
                              src: "9876:34:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_array$_t_uint160_$dyn_memory_ptr",
                                typeString: "uint160[] memory"
                              }
                            },
                            id: 520,
                            indexExpression: {
                              hexValue: "31",
                              id: 519,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "9922:1:0",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_1_by_1",
                                typeString: "int_const 1"
                              },
                              value: "1"
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "9876:57:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint160",
                              typeString: "uint160"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "-",
                          rightExpression: {
                            baseExpression: {
                              id: 521,
                              name: "secondsPerLiquidityCumulativeX128s",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 503,
                              src: "9936:34:0",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_array$_t_uint160_$dyn_memory_ptr",
                                typeString: "uint160[] memory"
                              }
                            },
                            id: 523,
                            indexExpression: {
                              hexValue: "30",
                              id: 522,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "9971:1:0",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "9936:37:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint160",
                              typeString: "uint160"
                            }
                          },
                          src: "9876:97:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint160",
                            typeString: "uint160"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "9830:143:0"
                      },
                      {
                        assignments: [527],
                        declarations: [
                          {
                            constant: false,
                            id: 527,
                            mutability: "mutable",
                            name: "secondsAgoX160",
                            nameLocation: "10105:14:0",
                            nodeType: "VariableDeclaration",
                            scope: 554,
                            src: "10097:22:0",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint192",
                              typeString: "uint192"
                            },
                            typeName: {
                              id: 526,
                              name: "uint192",
                              nodeType: "ElementaryTypeName",
                              src: "10097:7:0",
                              typeDescriptions: {
                                typeIdentifier: "t_uint192",
                                typeString: "uint192"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 538,
                        initialValue: {
                          commonType: {
                            typeIdentifier: "t_uint192",
                            typeString: "uint192"
                          },
                          id: 537,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            arguments: [
                              {
                                id: 530,
                                name: "secondsAgo",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 457,
                                src: "10130:10:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint32",
                                  typeString: "uint32"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint32",
                                  typeString: "uint32"
                                }
                              ],
                              id: 529,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "10122:7:0",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint192_$",
                                typeString: "type(uint192)"
                              },
                              typeName: {
                                id: 528,
                                name: "uint192",
                                nodeType: "ElementaryTypeName",
                                src: "10122:7:0",
                                typeDescriptions: {}
                              }
                            },
                            id: 531,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "10122:19:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint192",
                              typeString: "uint192"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "*",
                          rightExpression: {
                            expression: {
                              arguments: [
                                {
                                  id: 534,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "10149:7:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_uint160_$",
                                    typeString: "type(uint160)"
                                  },
                                  typeName: {
                                    id: 533,
                                    name: "uint160",
                                    nodeType: "ElementaryTypeName",
                                    src: "10149:7:0",
                                    typeDescriptions: {}
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_type$_t_uint160_$",
                                    typeString: "type(uint160)"
                                  }
                                ],
                                id: 532,
                                name: "type",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -27,
                                src: "10144:4:0",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_function_metatype_pure$__$returns$__$",
                                  typeString: "function () pure"
                                }
                              },
                              id: 535,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "10144:13:0",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_magic_meta_type_t_uint160",
                                typeString: "type(uint160)"
                              }
                            },
                            id: 536,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "10158:3:0",
                            memberName: "max",
                            nodeType: "MemberAccess",
                            src: "10144:17:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint160",
                              typeString: "uint160"
                            }
                          },
                          src: "10122:39:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint192",
                            typeString: "uint192"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "10097:64:0"
                      },
                      {
                        expression: {
                          id: 552,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 539,
                            name: "harmonicMeanLiquidity",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 460,
                            src: "10169:21:0",
                            typeDescriptions: {
                              typeIdentifier: "t_uint128",
                              typeString: "uint128"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                commonType: {
                                  typeIdentifier: "t_uint192",
                                  typeString: "uint192"
                                },
                                id: 550,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  id: 542,
                                  name: "secondsAgoX160",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 527,
                                  src: "10210:14:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint192",
                                    typeString: "uint192"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: "/",
                                rightExpression: {
                                  components: [
                                    {
                                      commonType: {
                                        typeIdentifier: "t_uint192",
                                        typeString: "uint192"
                                      },
                                      id: 548,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftExpression: {
                                        arguments: [
                                          {
                                            id: 545,
                                            name: "secondsPerLiquidityCumulativesDelta",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 517,
                                            src: "10236:35:0",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint160",
                                              typeString: "uint160"
                                            }
                                          }
                                        ],
                                        expression: {
                                          argumentTypes: [
                                            {
                                              typeIdentifier: "t_uint160",
                                              typeString: "uint160"
                                            }
                                          ],
                                          id: 544,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: true,
                                          lValueRequested: false,
                                          nodeType:
                                            "ElementaryTypeNameExpression",
                                          src: "10228:7:0",
                                          typeDescriptions: {
                                            typeIdentifier:
                                              "t_type$_t_uint192_$",
                                            typeString: "type(uint192)"
                                          },
                                          typeName: {
                                            id: 543,
                                            name: "uint192",
                                            nodeType: "ElementaryTypeName",
                                            src: "10228:7:0",
                                            typeDescriptions: {}
                                          }
                                        },
                                        id: 546,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: "typeConversion",
                                        lValueRequested: false,
                                        nameLocations: [],
                                        names: [],
                                        nodeType: "FunctionCall",
                                        src: "10228:44:0",
                                        tryCall: false,
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint192",
                                          typeString: "uint192"
                                        }
                                      },
                                      nodeType: "BinaryOperation",
                                      operator: "<<",
                                      rightExpression: {
                                        hexValue: "3332",
                                        id: 547,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: "number",
                                        lValueRequested: false,
                                        nodeType: "Literal",
                                        src: "10276:2:0",
                                        typeDescriptions: {
                                          typeIdentifier: "t_rational_32_by_1",
                                          typeString: "int_const 32"
                                        },
                                        value: "32"
                                      },
                                      src: "10228:50:0",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint192",
                                        typeString: "uint192"
                                      }
                                    }
                                  ],
                                  id: 549,
                                  isConstant: false,
                                  isInlineArray: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  nodeType: "TupleExpression",
                                  src: "10227:52:0",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint192",
                                    typeString: "uint192"
                                  }
                                },
                                src: "10210:69:0",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint192",
                                  typeString: "uint192"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint192",
                                  typeString: "uint192"
                                }
                              ],
                              id: 541,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "10193:7:0",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint128_$",
                                typeString: "type(uint128)"
                              },
                              typeName: {
                                id: 540,
                                name: "uint128",
                                nodeType: "ElementaryTypeName",
                                src: "10193:7:0",
                                typeDescriptions: {}
                              }
                            },
                            id: 551,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "10193:94:0",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint128",
                              typeString: "uint128"
                            }
                          },
                          src: "10169:118:0",
                          typeDescriptions: {
                            typeIdentifier: "t_uint128",
                            typeString: "uint128"
                          }
                        },
                        id: 553,
                        nodeType: "ExpressionStatement",
                        src: "10169:118:0"
                      }
                    ]
                  }
                }
              ]
            },
            documentation: {
              id: 453,
              nodeType: "StructuredDocumentation",
              src: "8683:485:0",
              text: "@notice Same as `consult` in {OracleLibrary} but saves gas by not calculating `arithmeticMeanTick`.\n @dev Silently handles OLD errors in `uniswapV3Pool.observe` to avoid reverting `updatePool`.\n @param pool Address of the pool that we want to observe\n @param secondsAgo Number of seconds in the past from which to calculate the time-weighted means\n @return harmonicMeanLiquidity The harmonic mean liquidity from (block.timestamp - secondsAgo) to block.timestamp"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getHarmonicMeanLiquidity",
            nameLocation: "9180:25:0",
            parameters: {
              id: 458,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 455,
                  mutability: "mutable",
                  name: "pool",
                  nameLocation: "9214:4:0",
                  nodeType: "VariableDeclaration",
                  scope: 557,
                  src: "9206:12:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 454,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9206:7:0",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 457,
                  mutability: "mutable",
                  name: "secondsAgo",
                  nameLocation: "9227:10:0",
                  nodeType: "VariableDeclaration",
                  scope: 557,
                  src: "9220:17:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint32",
                    typeString: "uint32"
                  },
                  typeName: {
                    id: 456,
                    name: "uint32",
                    nodeType: "ElementaryTypeName",
                    src: "9220:6:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint32",
                      typeString: "uint32"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9205:33:0"
            },
            returnParameters: {
              id: 461,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 460,
                  mutability: "mutable",
                  name: "harmonicMeanLiquidity",
                  nameLocation: "9281:21:0",
                  nodeType: "VariableDeclaration",
                  scope: 557,
                  src: "9273:29:0",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint128",
                    typeString: "uint128"
                  },
                  typeName: {
                    id: 459,
                    name: "uint128",
                    nodeType: "ElementaryTypeName",
                    src: "9273:7:0",
                    typeDescriptions: {
                      typeIdentifier: "t_uint128",
                      typeString: "uint128"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9272:31:0"
            },
            scope: 558,
            stateMutability: "view",
            virtual: false,
            visibility: "private"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 10,
              name: "IPriceFeed",
              nameLocations: ["488:10:0"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 640,
              src: "488:10:0"
            },
            id: 11,
            nodeType: "InheritanceSpecifier",
            src: "488:10:0"
          }
        ],
        canonicalName: "PriceFeed",
        contractDependencies: [],
        contractKind: "contract",
        documentation: {
          id: 9,
          nodeType: "StructuredDocumentation",
          src: "336:129:0",
          text: " @title PriceFeed\n @author jacopo.eth <jacopo@slice.so>\n @notice General purpose price feed based on Uniswap V3."
        },
        fullyImplemented: true,
        linearizedBaseContracts: [558, 640],
        name: "PriceFeed",
        nameLocation: "475:9:0",
        scope: 559,
        usedErrors: [19182]
      }
    ],
    license: "MIT"
  },
  id: 0
}
